/* eslint-disable react-hooks/exhaustive-deps */
import { Card, CircularProgress, Divider, useMediaQuery } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ReactTimeAgo from "react-time-ago";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../Icons/Dot";
import cssClasses from "./Home.module.css";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import Button from "../../Subcomponents/Button";
import TokenIcon from "../../Assets/Images/Token/token.svg";
import BoughtOnIcon from "../../Assets/Images/Token/boughton.svg";
import ValidTillIcon from "../../Assets/Images/Token/valid.svg";
import TokenPayment from "../../Modals/TokenPayment/TokenPayment";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { errorTost, successTost } from "../../Services/Toast";
import {
  getPreselectPaymentConfig,
  createTokenPaymentLink,
  getTokenPaymentLink,
  eventTokenPaymentLink,
  priorityPassToken,
  getTokenServerTime,
} from "../../Services/Tokens";
import {
  createPaymentOrder,
  getPaymentPlansPriceFromServer,
  getPreselectConfirmationsConfig,
  getPyamentLink,
  sdrPaymentMode,
} from "../../Services/Allotment";
import MyTimer from "../../Subcomponents/Timer";
import LinkedToken from "../../Modals/LinkedToken/LinkedToken";
import { useSelector } from "react-redux";
import BuyToken from "../../Modals/BuyToken/BuyToken";
import PreselectConfirmation from "../../Modals/PreselectConfirmation/PreselectConfirmation";
import BookingForm from "../../Modals/BookingForm/BookingForm";
import { supabase } from "../../supabaseClient";
import {
  numberWithCommas,
  tokenPaymentComplete,
} from "../../Assets/Common/CommonFunctions";
import DiscountImg from "../../Assets/Images/Common/disountImg.PNG";
import Congratulation from "../../Modals/PreselectConfirmation/Congratulation";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as actionTypes from "../../Redux Store/actionType/action-type";
import PaymentGatewaySelection from "../../Modals/PaymentGateway/PaymentGatewaySelection";
import usePaymentConsent, { tokenConsentSummary } from "../../Modals/PaymentConsent/usePaymentConsent";
import useAllotmentEsign from "../../Modals/AllotmentEsign/useAllotmentEsign";
import { preselectFillKycShown, preselectPayNowLocked, KYC_FIRST_TEXT } from "../../Modals/AllotmentEsign/preselectKyc";
import { CONSENT_TYPES } from "../../Services/Consent";

const Token = ({
  token,
  serverTime: _serverTime,
  allotment: _allotment,
  updatedRecord = [],
  handleUpdateRecord,
}) => {
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const { requireConsent, consentModal } = usePaymentConsent();
  const { requireEsign, esignModal } = useAllotmentEsign();
  TimeAgo.setDefaultLocale(en.locale);
  TimeAgo.addLocale(en);
  const navigate = useNavigate();
  const [allotment, set_Allotment] = useState({ ..._allotment } || {});
  const [serverTime, setServerTime] = useState(_serverTime || "");
  const [selectedToken, setSelectedToken] = useState(token);
  const [openTokenPaymentModal, setOpenTokenPaymentModal] = useState(false);
  const [openLinkedTokenModal, setOpenLinkedTokenModal] = useState(false);
  const [tokenObj, setTokenObj] = useState({});
  const [selectedTokenPaymentData, setSelectedTokenPaymentData] =
    useState(null);
  const selectedLead = JSON.parse(localStorage.getItem("selectedLead"));
  const [openBuyTokenModal, setOpenBuyTokenModal] = useState(false);
  const [upgradableTokens, setUpgradableTokens] = useState([]);
  const [prereqToken, setPrereqToken] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [message, setMessage] = useState("");
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [openCong, setOpenCong] = useState(false);
  const [fastbooking, setFastBooking] = useState(false); // for adding book now button for fastbooking
  const isMobileView = useMediaQuery("(max-width:720px)");
  const [currentAllotmentPayment, setCurrentAllotmentPayment] = useState();
  const [openBookingFormModal, setOpenBookingFormModal] = useState(false);
  const isWrap = useMediaQuery("(max-width:1440px)");
  const timeoutId1 = useRef(null);
  const msgTimeoutId1 = useRef(null);
  const timeoutId2 = useRef(null);
  const msgTimeoutId2 = useRef(null);
  const [updatedUnitCost, setUpdatedUnitCost] = useState({
    bsp: "",
    gst: "",
    sdr: "",
    total: "",
  });
  const [openPaymentGatewaySelectionModal, setOpenPaymentGatewaySelectionModal] = useState(false);
  const [selectedPayableAmount, setSelectedPayableAmount] = useState(0);
 
   const handleOpenPaymentGatewaySelectionModal = (payableAmount) => {
     console.log("token payableAmount received1 ===> ", payableAmount);
     setSelectedPayableAmount(payableAmount);
     setOpenPaymentGatewaySelectionModal(true);
   }

  const expiretimeoutId = useRef(null);
  const dispatch = useDispatch();

  const getServerTime = async () => {
    getTokenServerTime()
      .then((res) => {
        // console.log("server Time==>", res?.data?.currentTime, serverTime);
        setServerTime(res?.data?.currentTime);
      })
      .catch((error) => {
        console.log("err in getQueueStatus api call", error);
      });
  };

  useEffect(() => {
    let newAllotment = { ..._allotment };
    getTokenServerTime()
      .then((res) => {
        setServerTime(res?.data?.currentTime);
        const time = res?.data?.currentTime;
        if (allotment?.launchId) {
          getPreselectConfirmationsConfig(
            newAllotment?.paymentId?.eventId,
            newAllotment?.paymentId?.eventTokenId?.eventTokenId,
            newAllotment?.launchId
          )
            .then((val) => {
              newAllotment.showConfirmBtn = false;
              newAllotment.showMsg = false;
              newAllotment.isExpired = false;
              // dismissLoader();
              newAllotment.discountPercentage =
                val?.data?.length > 0 ? val?.data[0]?.priceDiscount : 0;
              newAllotment.showPreselectPrices =
                val?.data?.length > 0 ? val?.data[0]?.showPreselectPrices : [];

              newAllotment.paymentId.eventTokenId.eventId.preselectConfirmationConfig =
                val?.data?.length > 0
                  ? val?.data[0]?.preselectConfirmationConfig
                  : newAllotment.paymentId.eventTokenId.eventId
                      .preselectConfirmationConfig;
              if (
                newAllotment.paymentId?.eventTokenId?.eventId
                  ?.preselectConfirmationConfig?.endDateTime -
                  Date.now() <=
                parseInt(
                  newAllotment.paymentId?.eventTokenId?.eventId
                    ?.preselectConfirmationConfig?.timer
                ) *
                  60000
              ) {
                newAllotment.expiry =
                  newAllotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.endDateTime;
                getServerTime();
              } else {
                console.log("expiry", false);
              }
              if (
                val?.data?.length > 0
                  ? val?.data[0]?.preselectConfirmationConfig?.startDateTime
                  : newAllotment?.paymentId?.eventTokenId?.eventId
                      ?.preselectConfirmationConfig?.startDateTime > time
              ) {
                clearTimeout(timeoutId2.current);
                clearTimeout(timeoutId1.current);
                timeoutId1.current = setTimeout(() => {
                  set_Allotment({
                    ..._allotment,
                    showPreselectPrices:
                      val?.data?.length > 0
                        ? val?.data[0]?.showPreselectPrices
                        : [],
                    closeTimer:
                      val?.data?.length > 0
                        ? val?.data[0]?.preselectConfirmationConfig?.endDateTime
                        : newAllotment?.paymentId?.eventTokenId?.eventId
                            ?.preselectConfirmationConfig?.endDateTime,
                    timer:
                      val?.data?.length > 0
                        ? val?.data[0]?.preselectConfirmationConfig
                            ?.startDateTime
                        : newAllotment.paymentId?.eventTokenId?.eventId
                            ?.preselectConfirmationConfig?.startDateTime,
                    showConfirmBtn: true,
                    showMsg: false,
                  });
                }, newAllotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.startDateTime - time);
                clearTimeout(expiretimeoutId.current);
                expiretimeoutId.current = setTimeout(() => {
                  set_Allotment({
                    ..._allotment,
                    showPreselectPrices:
                      val?.data?.length > 0
                        ? val?.data[0]?.showPreselectPrices
                        : [],
                    closeTimer:
                      val?.data?.length > 0
                        ? val?.data[0]?.preselectConfirmationConfig?.endDateTime
                        : newAllotment?.paymentId?.eventTokenId?.eventId
                            ?.preselectConfirmationConfig?.endDateTime,
                    timer:
                      val?.data?.length > 0
                        ? val?.data[0]?.preselectConfirmationConfig
                            ?.startDateTime
                        : newAllotment.paymentId?.eventTokenId?.eventId
                            ?.preselectConfirmationConfig?.startDateTime,
                    showConfirmBtn: false,
                    showMsg: false,
                    isExpired: true,
                  });
                }, newAllotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.endDateTime - time);
                if (
                  val?.data?.length > 0 &&
                  val?.data[0]?.preselectConfirmationConfig?.startDateTime >
                    time &&
                  newAllotment.preselectConfirmation === "confirmation pending"
                ) {
                  clearTimeout(msgTimeoutId2.current);
                  clearTimeout(msgTimeoutId1.current);
                  msgTimeoutId1.current = setTimeout(() => {
                    set_Allotment({
                      ..._allotment,
                      showPreselectPrices:
                        val?.data?.length > 0
                          ? val?.data[0]?.showPreselectPrices
                          : [],
                      showMsg: true,
                      showConfirmBtn: false,
                    });
                  }, newAllotment?.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.startDateTime - newAllotment?.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.timer * 60000 - time);
                }
              } else {
                newAllotment.timer =
                  val?.data?.length > 0
                    ? val?.data[0]?.preselectConfirmationConfig?.startDateTime
                    : newAllotment.paymentId?.eventTokenId?.eventId
                        ?.preselectConfirmationConfig?.startDateTime;
                newAllotment.closeTimer =
                  val?.data?.length > 0
                    ? val?.data[0]?.preselectConfirmationConfig?.endDateTime
                    : newAllotment.paymentId?.eventTokenId?.eventId
                        ?.preselectConfirmationConfig?.endDateTime;
              }
            })
            .catch((err) => {});
        } else {
          newAllotment.showConfirmBtn = false;
          newAllotment.showMsg = false;
          newAllotment.discountPercentage = 0;
          newAllotment.showCost = [];
          if (
            newAllotment.paymentId?.eventTokenId?.eventId
              ?.preselectConfirmationConfig?.endDateTime -
              Date.now() <=
            parseInt(
              newAllotment.paymentId?.eventTokenId?.eventId
                ?.preselectConfirmationConfig?.timer
            ) *
              60000
          ) {
            newAllotment.expiry =
              newAllotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.endDateTime;
          } else {
            console.log("expiry", false);
          }
          if (
            newAllotment.paymentId?.eventTokenId?.eventId
              ?.preselectConfirmationConfig?.startDateTime >
            new Date().getTime()
          ) {
            setTimeout(() => {
              set_Allotment({
                ..._allotment,
                closeTimer:
                  newAllotment.paymentId?.eventTokenId?.eventId
                    ?.preselectConfirmationConfig?.endDateTime,
                timer:
                  newAllotment.paymentId?.eventTokenId?.eventId
                    ?.preselectConfirmationConfig?.startDateTime,
                showConfirmBtn: true,
              });
            }, newAllotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.startDateTime - new Date().getTime());
          } else {
            newAllotment.timer = newAllotment.paymentId?.eventTokenId?.eventId
              ?.preselectConfirmationConfig
              ? newAllotment.paymentId?.eventTokenId?.eventId
                  ?.preselectConfirmationConfig?.startDateTime
              : null;
            newAllotment.closeTimer = newAllotment.paymentId?.eventTokenId
              ?.eventId?.preselectConfirmationConfig
              ? newAllotment.paymentId?.eventTokenId?.eventId
                  ?.preselectConfirmationConfig?.endDateTime
              : null;
          }
        }
      })
      .catch((error) => {
        console.log("err in getQueueStatus api call", error);
      });
    set_Allotment({ ...newAllotment });
  }, [handleUpdateRecord]);
  useEffect(() => {
    const handleRecordUpdated = updatedRecord.find(
      (token) =>
        token?.new?.launchId === allotment?.launchId &&
        token.new.eventId === allotment?.paymentId?.eventId &&
        token.new.eventTokenId ===
          allotment?.paymentId?.eventTokenId?.eventTokenId
    );
    if (handleRecordUpdated) {
      getTokenServerTime()
        .then((res) => {
          setServerTime(res?.data?.currentTime);
          setnewConfig(handleRecordUpdated, res?.data?.currentTime);
        })
        .catch((error) => {
          console.log("err in getQueueStatus api call", error);
        });
    }
  }, [updatedRecord]);
  useEffect(() => {
    if (_allotment?.paymentPlanId) {
      getPaymentPlansPriceFromServer(
        _allotment?.paymentPlanId,
        _allotment?.unitId?.unitId
      )
        .then((planResp) => {
          if (planResp?.data[0]) {
            setUpdatedUnitCost({
              bsp: planResp.data[0]?.BSP,
              gst: planResp.data[0]?.GST,
              sdr: planResp.data[0]?.SDR,
              total: planResp.data[0]?.totalCost,
            });
          } else {
            setUpdatedUnitCost({
              bsp: _allotment?.unitId?.BSP,
              gst: _allotment?.unitId?.GST,
              sdr: _allotment?.unitId?.SDR,
              total: _allotment?.unitId?.totalCost,
            });
          }
        })
        .catch((err) => {
          setUpdatedUnitCost({
            bsp: _allotment?.unitId?.BSP,
            gst: _allotment?.unitId?.GST,
            sdr: _allotment?.unitId?.SDR,
            total: _allotment?.unitId?.totalCost,
          });
          errorTost("Error While getting Payment Plan Details.");
          console.log(err.message);
        });
    } else {
      setUpdatedUnitCost({
        bsp: _allotment?.unitId?.BSP,
        gst: _allotment?.unitId?.GST,
        sdr: _allotment?.unitId?.SDR,
        total: _allotment?.unitId?.totalCost,
      });
    }
  }, [_allotment]);
  const setnewConfig = (newConfigData, time = serverTime) => {
    let newAllotment = { ..._allotment };
    newAllotment.showConfirmBtn = false;
    newAllotment.showMsg = false;
    newAllotment.isExpired = false;
    newAllotment.showPreselectPrices = newConfigData.new.showPreselectPrices;
    newAllotment.paymentId.eventTokenId.eventId.preselectConfirmationConfig =
      newConfigData?.new?.preselectConfirmationConfig;

    if (
      newAllotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig
        ?.endDateTime -
        Date.now() <=
      parseInt(
        newAllotment.paymentId?.eventTokenId?.eventId
          ?.preselectConfirmationConfig?.timer
      ) *
        60000
    ) {
      console.log("expiry", true);
      newAllotment.expiry =
        newAllotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.endDateTime;
      console.log("newAllotment.expiry: ", newAllotment.expiry);
      getServerTime();
    } else {
      console.log("expiry", false);
    }
    if (
      newConfigData.new.preselectConfirmationConfig?.startDateTime > time ||
      time < newConfigData.new.preselectConfirmationConfig?.endDateTime
    ) {
      clearTimeout(timeoutId1.current);
      clearTimeout(timeoutId2.current);
      timeoutId2.current = setTimeout(() => {
        set_Allotment({
          ..._allotment,
          showPreselectPrices: newConfigData.new.showPreselectPrices,
          closeTimer:
            newConfigData.new.preselectConfirmationConfig?.endDateTime,
          timer: newConfigData.new.preselectConfirmationConfig?.startDateTime,
          showConfirmBtn: true,
          showMsg: false,
        });
      }, newConfigData.new.preselectConfirmationConfig?.startDateTime - time);
      clearTimeout(expiretimeoutId.current);
      expiretimeoutId.current = setTimeout(() => {
        set_Allotment({
          ..._allotment,
          showPreselectPrices: newConfigData.new.showPreselectPrices,
          closeTimer:
            newConfigData.new.preselectConfirmationConfig?.endDateTime,
          timer: newConfigData.new.preselectConfirmationConfig?.startDateTime,
          showConfirmBtn: false,
          showMsg: false,
          isExpired: true,
        });
      }, newConfigData.new.preselectConfirmationConfig?.endDateTime - time);
      if (
        newConfigData.new.preselectConfirmationConfig?.startDateTime > time &&
        newAllotment.preselectConfirmation === "confirmation pending"
      ) {
        clearTimeout(msgTimeoutId1.current);
        clearTimeout(msgTimeoutId2.current);
        msgTimeoutId2.current = setTimeout(() => {
          set_Allotment({
            ..._allotment,
            showPreselectPrices: newConfigData.new.showPreselectPrices,
            showMsg: true,
            showConfirmBtn: false,
          });
        }, newAllotment?.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.startDateTime - newAllotment?.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.timer * 60000 - time);
      }
    }
    set_Allotment({ ...newAllotment });
  };

  function UpdatePreselectUpdate(respValue) {
    if (respValue === true) {
      setOpenCong(true);
    }
  }

  async function updateTokenTables(amt) {
    presentLoader();
    setOpenTokenPaymentModal(false);
    // !todo 1. check if token is preselect
    // !todo 2. if preselect, get payment settings from event settings
    // !todo 3. if not preselect, get payment settings from settings tab
    if (selectedToken.eventTokenId.tokenId.isPreselect) {
      getPreselectPaymentConfig(selectedToken.eventId.eventId)
        .then(async (config) => {
          if (config[0].preselectPaymentModes.includes("Customer In-App")) {
            const obj = {
              transactionObj: {
                transactionType: "preselect",
                modeOfPayment: "Razorpay-Customer Portal",
                allotmentPaymentId:
                  selectedToken.allotmentPaymentId?.allotmentPaymentId,
                unitId: selectedToken?.allotmentPaymentId?.unitId?.unitId,
                inventoryMergeId:
                  selectedToken?.allotmentPaymentId?.inventoryMergedId
                    ?.inventoryMergeId,
                leadId: selectedToken.leadId,
                status: "pending",
                amount: amt,
              },
              amount: amt,
              type: "Allotment",
            };

            await createPaymentOrder(obj)
              .then(async (order) => {
                if (order?.data?.success) {
                  dismissLoader();
                  const options = {
                    key: process.env.REACT_APP_RAZOR_PAY_KEY,
                    amount: amt * 100,
                    currency: "INR",
                    name: "VJ Developers",
                    partial_payment: true,
                    description:
                      "Payment for token " + selectedToken.tokenNumber,
                    order_id: order.data.id,
                  };
                  const rzp1 = new window.Razorpay(options);
                  rzp1.open();
                } else if (order?.data?.message) {
                  console.log("message", message);
                  dismissLoader();
                  errorTost(order?.data?.message);
                } else {
                  dismissLoader();
                  errorTost("Couldn't create order! please try again later");
                }
              })
              .catch((err) => {
                console.log("err: ", err);
                dismissLoader();
                errorTost("Network Error. Please try again later!");
              });
          } else if (config[0].preselectPaymentModes.includes("Razorpay")) {
            await createTokenPaymentLink(amt, "allotment", selectedToken)
              .then((create) => {
                if (create.data.success) {
                  getTokenPaymentLink(create.data.paymentLinkId)
                    .then((resp) => {
                      if (resp.data) {
                        setSelectedToken(null);
                        successTost(
                          "Payment link sent on registered mobile number!"
                        );
                        let anchor = document.createElement("a");
                        anchor.href = resp.data.link;
                        anchor.target = "_blank";
                        anchor.click();
                        dismissLoader();
                      } else {
                        dismissLoader();
                        errorTost(
                          "Create Payment Failed! Please try again later"
                        );
                      }
                    })
                    .catch((err) => {
                      console.log("err: ", err);
                      dismissLoader();
                      errorTost("Network Error. Please try again later!");
                    });
                } else {
                  dismissLoader();
                  errorTost("Couldn't create order! please try again later");
                }
              })
              .catch((err) => {
                console.log("Error", err);
                errorTost("Create Payment Failed! Please try again later");
              });
          }
        })
        .catch((err) => {
          console.log("Error", err);
          errorTost(
            "Error While getting Preselect Details! Please try again later"
          );
        });
    } else {
      sdrPaymentMode()
        .then(async (resp) => {
          // const currentDate = new Date();
          if (resp.data[0].useLinkInCustomerAppForToken) {
            eventTokenPaymentLink(amt, selectedToken).then((create) => {
              if (create.data.success) {
                getPyamentLink(create.data.paymentLinkId)
                  .then((resp) => {
                    if (resp.data) {
                      setSelectedToken(null);
                      successTost(
                        "Payment link sent on registered mobile number!"
                      );
                      let anchor = document.createElement("a");
                      anchor.href = resp.data.link;
                      anchor.target = "_blank";
                      anchor.click();
                      dismissLoader();
                    } else {
                      dismissLoader();
                      errorTost(
                        "Couldn't create order! please try again later"
                      );
                    }
                  })
                  .catch((err) => {
                    dismissLoader();
                    console.log(
                      "Couldn't create order! please try again later"
                    );
                  });
              } else {
                dismissLoader();
                errorTost(create.data.message);
              }
            });
          } else {
            const obj = {
              amount: amt,
              type: "Token",
              transactionObj: {
                eventTokenId: selectedToken.eventTokenId.eventTokenId,
                paymentId: selectedToken.paymentId,
                leadId: selectedToken.leadId,
                status: "pending",
                amount: amt,
              },
            };
            await createPaymentOrder(obj)
              .then(async (order) => {
                if (order?.data?.success) {
                  dismissLoader();
                  const options = {
                    key: process.env.REACT_APP_RAZOR_PAY_KEY, // Enter the Key ID generated from the Dashboard
                    // amount: token.eventTokenId.tokenId.isPreselect ? 50000000 : (token.amount - token.paidAmount) * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
                    // ? token amount for preselect token as well
                    // ! vedashree to change this amount
                    amount: amt * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
                    currency: "INR",
                    name: "VJ Developers",
                    partial_payment: true,
                    description:
                      "Payment for token " + selectedToken.tokenNumber,
                    order_id: order.data.id,
                  };

                  const rzp1 = new window.Razorpay(options);
                  // rzp1.on("payment.failed", function (response) {
                  // 	// ?todo: show loader modal
                  // });
                  rzp1.open();
                } else {
                  dismissLoader();
                  errorTost("Token limit exceeded.");
                }
              })
              .catch((err) => {
                console.log("err: ", err);
                dismissLoader();
                errorTost("Network Error. Please try again later!");
              });
          }
        })
        .catch((err) => {
          console.log("err: ", err);
          dismissLoader();
          errorTost("Network Error. Please try again later!");
        });
    }
  }

  function addPriorityPasstoken(ppTokenData) {
    presentLoader();
    const ppObj = {
      eventTokenId: ppTokenData,
      gtPaymentId: prereqToken.paymentId,
      leadId: selectedLead.leadId,
      paidAmount: 0,
      amount: ppTokenData.tokenId.amount,
      TokenTransactions: [],
    };

    setSelectedToken(ppObj);
    priorityPassToken(ppObj)
      .then((ppResp) => {
        if (ppResp?.data?.success?.length > 0) {
          setSelectedToken((pre) => {
            pre.paymentId = ppResp.data.success[0].paymentId;
            return { ...pre };
          });
          dismissLoader();
          setOpenBuyTokenModal(false);
          setOpenTokenPaymentModal(true);
        } else {
          errorTost("Try again in sometime!");
          dismissLoader();
        }
      })
      .catch((err) => {
        console.log("err: ", err);
        dismissLoader();
        errorTost("Network Error. Please try again later!");
      });
  }
  function arrayContains(key, arr) {
    return arr.indexOf(key) > -1;
  }

  //timer for diwali 2025 launch
  // timer for diwali 2025 launch
  // ✅ Server-synced timer for Diwali 2025 launch
  const [serverClock, setServerClock] = useState(null);
  const [offset, setOffset] = useState(0);

  // 1️⃣ Fetch server time from backend
  const FetchServerTime = async () => {
    try {
      const res = await getTokenServerTime();
      const serverUTC = new Date(res?.data?.currentTime).getTime();
      const localNow = Date.now();
      setServerClock(serverUTC);
      setOffset(localNow - serverUTC); // difference between local and server clock
    } catch (error) {
      console.log("Error fetching server time:", error);
    }
  };

  // 2️⃣ Fetch immediately + refresh every 5 minutes
  useEffect(() => {
    FetchServerTime();
    const interval = setInterval(getServerTime, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  // 3️⃣ Diwali Launch Date
  // const eventDate = "2025-10-28T16:10:00"; // yyyy-mm-ddThh:mm:ss

  const [eventDate, setEventDate] = useState(null);
  const [timeRemaining, setTimeRemaining] = useState("Loading...");
  const [isTimerFinished, setIsTimerFinished] = useState(false);
  const [isBookingAvailable, setIsBookingAvailable] = useState(false);

  const eventStartDate = token?.eventId?.EventOnlineBookingConfig[0]?.startDate
    ? token?.eventId?.EventOnlineBookingConfig[0]?.startDate
    : 0;
  const eventEndDate = token?.eventId?.EventOnlineBookingConfig[0]?.endDate
    ? token?.eventId?.EventOnlineBookingConfig[0]?.endDate
    : 0;

  const isEventActive = true;
  //  token?.eventId?.EventOnlineBookingConfig[0]
  //   ?.isOnlineBookingAccept
  //   ? token?.eventId?.EventOnlineBookingConfig[0]?.isOnlineBookingAccept
  //   : false;

  // Check booking availability based on server time and event dates

  useEffect(() => {
    const checkBookingAvailability = () => {
      if (!serverClock || !eventStartDate || !eventEndDate) return;

      if (serverClock >= eventStartDate && serverClock <= eventEndDate) {
        setIsBookingAvailable(true);
      } else {
        setIsBookingAvailable(false);
      }
    };

    checkBookingAvailability();
  }, [serverClock]);

  // Calculate time remaining
  useEffect(() => {
    const computeRemaining = () => {
      if (!serverClock || !eventStartDate)
        // Corrected here
        return { finished: false, text: "Loading..." };

      const now = Date.now() - offset; // Simulate server time
      const diff = new Date(eventStartDate).getTime() - now; // Corrected here

      if (diff <= 0) return { finished: true, text: "0d : 0hrs : 0min : 0s" };

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      return {
        finished: false,
        text: `${days}d : ${hours}hrs : ${minutes}min : ${seconds}s`,
      };
    };

    const initial = computeRemaining();
    setTimeRemaining(initial.text);
    setIsTimerFinished(initial.finished);

    const updateTimer = () => {
      const updated = computeRemaining();
      setTimeRemaining(updated.text);
      setIsTimerFinished(updated.finished);
    };

    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [serverClock, eventStartDate, offset]);

  const [loading, setLoading] = useState(false);

  const handleBooking = async () => {
    setLoading(true);
    try {
      // if (isEventActive === false) {
      // if(isEventActive === true){    // temp change to true for testing
      //   navigate("/Home/Tokens");
      //   return;
      // }
      console.log({
        TEST: "TEST",
        paymentId: token?.paymentId,
        tokenNo: token?.tokenNumber,
      });

      navigate("/Home/BuildingSelection", {
        state: { paymentId: token?.paymentId, tokenNo: token?.tokenNumber },
      });
      // }
      // if (isEventActive === true) {
      //   const res = await axios.post(
      //     `${process.env.REACT_APP_PAYMENT_LINK_URL}customerOnlineBooking/getAllUnitsFromLaunchesForCustomerFastBooking`
      //   );

      // if (res.data?.data) {
      //   navigate("/Home/UnitFloorMap", {
      //     state: {
      //       data: res.data.data,
      //       paymentId: token?.paymentId,
      //       tokenNo: token?.tokenNumber,
      //     },
      //   });
      //    }
      // }
    } catch (error) {
      console.error("Error fetching units:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <div>
        {token && (
          <Card
            className={cssClasses.tokenEventWrap}
            style={{ borderRadius: "20px", boxShadow: "none" }}
          >
            <div className={cssClasses.tokenCardHeader}>
              <div className={cssClasses.tokenCardHeaderSection}>
                <div>
                  <img src={TokenIcon} alt="token" />
                </div>
                <div>
                  <div>
                    {token.paidAmount === token.amount && (
                      <div className={cssClasses.tokenNumWrap}>
                        <span>VJ{token.tokenNumber}</span>
                      </div>
                    )}
                    <div className={cssClasses.tokenDataShow}>
                      <div className={cssClasses.tokenNoData}>
                        <span className={cssClasses.tokenNoData}>
                          {token.eventTokenId.tokenId.name}
                        </span>
                      </div>
                    </div>

                    {token.eventTokenId.tokenId.isPreselect && (
                      <span style={{ fontSize: "1.4rem" }}>Preselect</span>
                    )}
                  </div>
                  <div className={cssClasses.tokenStatus}>
                    {token.status === "pending" && (
                      <LeadStatusChip
                        label={token.status}
                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                        style={{
                          color: "#B42318",
                          backgroundColor: "#FEF3F2",
                        }}
                      ></LeadStatusChip>
                    )}
                    {token.status === "partial" && (
                      <LeadStatusChip
                        label={token.status}
                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                        style={{
                          color: "#B42318",
                          backgroundColor: "#FEF3F2",
                        }}
                      ></LeadStatusChip>
                    )}
                    {token.status === "active" && (
                      <LeadStatusChip
                        label={token.status}
                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                        style={{
                          color: "#027A48",
                          backgroundColor: "#ECFDF3",
                        }}
                      ></LeadStatusChip>
                    )}
                    {token.status === "alloted" && (
                      <LeadStatusChip
                        label={
                          token.eventTokenId.tokenId.isPreselect
                            ? "Preselected"
                            : token.status
                        }
                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                        style={{
                          color: "#C11574",
                          backgroundColor: "#FDF2FA",
                        }}
                      />
                    )}

                    {(token.status === "refund requested" ||
                      token.status === "Upgraded" ||
                      token.status === "refund initiated") && (
                      <LeadStatusChip
                        label={token.status}
                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                        style={{
                          color: "#B54708",
                          backgroundColor: "#FFFAEB",
                        }}
                      ></LeadStatusChip>
                    )}
                    {(token.status === "refunded" ||
                      token.status === "refund processed" ||
                      token.status === "adjusted") && (
                      <LeadStatusChip
                        label={token.status}
                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                        style={{
                          color: "#E62E05",
                          backgroundColor: "#FFF4ED",
                        }}
                      ></LeadStatusChip>
                    )}
                    {token.status === "expired" && (
                      <LeadStatusChip
                        label={token.status}
                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                        style={{
                          color: "#0E7090",
                          backgroundColor: "#ECFDFF",
                        }}
                      ></LeadStatusChip>
                    )}
                    {token.status === "cancelled" && (
                      <LeadStatusChip
                        label={token.status}
                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                        style={{
                          color: "#B42318",
                          backgroundColor: "#FEF3F2",
                        }}
                      ></LeadStatusChip>
                    )}
                    {token.status === "refund rejected" && (
                      <LeadStatusChip
                        style={{
                          color: "#5925DC",
                          backgroundColor: "#F4F3FF",
                        }}
                        label={token.status}
                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                      />
                    )}
                    {token?.eventTokenId?.tokenId?.isPreselect &&
                      allotment?.preselectConfirmation ===
                        "confirmation pending" &&
                      token.status !== "expired" &&
                      !allotment?.status?.includes("Refund") && (
                        <LeadStatusChip
                          label={"Confirmation Pending"}
                          icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                          style={{
                            color: "#B54708",
                            backgroundColor: "#FFFAEB",
                          }}
                        ></LeadStatusChip>
                      )}
                    {token.eventTokenId.tokenId.isPreselect &&
                      !token.kycFormFilled && (
                        <LeadStatusChip
                          label={"Kyc Pending"}
                          icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                          style={{
                            color: "#0E7090",
                            backgroundColor: "#ECFDFF",
                          }}
                        ></LeadStatusChip>
                      )}
                    {token.eventTokenId.tokenId.isPreselect &&
                      token.kycFormFilled && (
                        <LeadStatusChip
                          label={"KYC Done"}
                          icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                          style={{
                            color: "#0E7090",
                            backgroundColor: "#ECFDFF",
                          }}
                        ></LeadStatusChip>
                      )}
                  </div>
                </div>
              </div>
              <div className={cssClasses.tokenLastUpdate}>
                <ReactTimeAgo
                  style={{ fontSize: "1.2rem" }}
                  date={token?.last_updated_at ?? token?.created_at}
                  locale="en-US"
                />
              </div>
            </div>
            {/* <div className={cssClasses.tokenDataShow}>
							<div className={cssClasses.tokenNoData}>
								<span className={cssClasses.tokenNoData}>{token.eventTokenId.tokenId.name}</span>
							</div>
						</div> */}
            <div className={cssClasses.tokenCardDetails}>
              <div className={cssClasses.tokeDetailsHeader}>
                <div>
                  <span>{token.eventId.title}</span>
                </div>
                {/* <div>
								{token.eventTokenId.tokenId.isPreselect && (
									<span>
										<LeadStatusChip
											label={"Preselect"}
											icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
											style={{
												color: "#5925DC",
												backgroundColor: "#EBE9FE",
											}}
										></LeadStatusChip>
									</span>
								)}
							</div> */}
              </div>
              <div className={cssClasses.tokenProjectData}>
                {token.eventTokenId.tokenId.isPreselect && (
                  <span>{token.projectDetails}</span>
                )}
              </div>
              <div className={cssClasses.tokenBoughtSection}>
                <div className={cssClasses.tokenBoughtData}>
                  <div className={cssClasses.dateText}>
                    <img src={BoughtOnIcon} alt="bought" />
                    <span>Bought on :</span>
                  </div>
                  <span>
                    {new Date(token.created_at).toDateString()},{" "}
                    {new Date(token.created_at).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span>
                </div>
                <div className={cssClasses.tokenBoughtData}>
                  <div className={cssClasses.dateText}>
                    <img src={ValidTillIcon} alt="valid" />
                    <span>Valid Till :</span>
                  </div>
                  <span>{token.validity}</span>
                </div>
              </div>
              {token.paidAmount >= token.amount &&
                token?.TokenTransactions?.length > 0 && (
                  <div className={cssClasses.tokenBoughtSection}>
                    <div className={cssClasses.tokenBoughtData}>
                      <div className={cssClasses.dateText}>
                        <img src={ValidTillIcon} alt="token" />
                        <span>Token Payment Complete :</span>
                      </div>
                      <span style={{ fontWeight: "600" }}>
                        {tokenPaymentComplete(token.TokenTransactions)}
                      </span>
                    </div>
                  </div>
                )}
            </div>
            {token.expiry && (
              <>
                {token.expiry > serverTime &&
                  token.paidAmount === 0 &&
                  !token.eventTokenId.tokenId.isPreselect && (
                    <div className={cssClasses.timerWrap}>
                      Expires On :
                      <MyTimer
                        showIcon={false}
                        css={{
                          fontSize: "1.8rem",
                          color: "#B42318",
                        }}
                        expiryTimestamp={token.expiry}
                        onExpire={() => {
                          // console.log("current token", token);
                          setOpenTokenPaymentModal(false);
                          // ! if priority pass; delete row from EventTokenLeadRelation & revert isPrerequisiteUsed & linkedTokenId of prerequisite token
                          // if (token.eventTokenId.tokenId.isPriorityPass && token.paidAmount === 0) {
                          // 	console.log("calling cancel priority pass token now for ", token);
                          // 	cancelPriorityPassToken(token);
                          // }
                        }}
                      />
                    </div>
                  )}
              </>
            )}
            {allotment.showConfirmBtn &&
              allotment.preselectConfirmation === "confirmation pending" &&
              token?.status !== "expired" && (
                <div className={cssClasses.allotmentPaymentPriceBreakDown}>
                  {arrayContains("BSP", allotment.showPreselectPrices) && (
                    <div className={cssClasses.allotmentPaymentPrice1}>
                      <span className={cssClasses.allotmentPriceText}>
                        Agreement Value:
                      </span>
                      <span>₹ {numberWithCommas(updatedUnitCost?.bsp)}</span>
                    </div>
                  )}

                  {arrayContains("SDR", allotment.showPreselectPrices) && (
                    <div className={cssClasses.allotmentPaymentPrice1}>
                      <span className={cssClasses.allotmentPriceText}>
                        SDR :
                      </span>
                      <span>₹ {numberWithCommas(updatedUnitCost?.sdr)}</span>
                    </div>
                  )}

                  {arrayContains("GST", allotment.showPreselectPrices) && (
                    <div className={cssClasses.allotmentPaymentPrice1}>
                      <span className={cssClasses.allotmentPriceText}>
                        GST :
                      </span>
                      <span>₹ {numberWithCommas(updatedUnitCost?.gst)}</span>
                    </div>
                  )}
                </div>
              )}
            {/* {console.log("allotment===>", allotment)} */}
            <div className={cssClasses.desktopDiv}>
              {allotment?.status !== "Cancelled" &&
                !allotment?.status?.includes("Refund") &&
                allotment.showConfirmBtn &&
                allotment.preselectConfirmation === "confirmation pending" && (
                  <div className={cssClasses.totalAmt}>
                    <span className={cssClasses.amtBtnsText}>
                      Total Cost (CLP) : </span>
                    <span>₹ {numberWithCommas(updatedUnitCost?.total)}</span>
                      <div
  style={{
    fontSize: "8px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "100%"
  }}
>
  CLP = Construction Link Payment Plan.
</div>
                  </div>
                )}
            </div>
            {/* <span style={{ fontSize : "8px", marginLeft: "1rem"}}>
              CLP = Construction Link Payment Plan.
            </span> */}
            <div style={{width: "100%"}}>
              {/* {console.log("staging allotment special cashback", allotment) } */}
              {/* {console.log("staging allotment allotment?.eventId", allotment?.eventId) }
              {console.log("staging allotment allotment?.status", allotment?.status) }
              {console.log("staging allotment allotment.showConfirmBtn", allotment.showConfirmBtn) }
              {console.log("staging allotment allotment?.preselectConfirmation", allotment?.preselectConfirmation) }
              {console.log("staging allotment token?.status", token?.status) } */}
              {(allotment?.eventId === "264a13c9-3519-467a-9ecb-3f682334baa1" || allotment?.eventId === "e8923af0-3f1e-4525-8dad-d125192c916f") &&
                allotment?.status !== "Cancelled" &&
                !allotment?.status?.includes("Refund") &&
                 // new Date(allotment?.timer) < new Date(serverTime) &&
                // new Date(allotment?.closeTimer) > new Date(serverTime) &&
                allotment.showConfirmBtn &&
                allotment?.preselectConfirmation === "confirmation pending" &&
                token?.status !== "expired" && (
                  <div
                    // className={cssClasses.backgroundDiv}
                    style={{ padding: "1rem", textAlign: "left", width: "100%", backgroundColor: "#efa04cff" }}
                  >
                    <div style={{ fontWeight: "bold", fontSize: "1.4rem"  }}>CONFIRM Now, Decide Later!</div>
                    <div style={{ fontSize: "1.4rem" }}>
                     For No Pre-EMI price, please refer detailed pricelist. Offer applicable only to PreSelect units.
                    </div>
                  </div>
                )}
            </div>
            {allotment?.eventId === "90d401ad-fe80-4295-95ab-07be3850d17b" &&
              allotment?.launchId === "373dfbbf-3edb-45bc-8a08-c174140c2a34" &&
              allotment?.status !== "Cancelled" &&
              !allotment?.status?.includes("Refund") &&
              allotment.showConfirmBtn &&
              allotment?.preselectConfirmation === "confirmation pending" &&
              token?.status !== "expired" && (
                <div className={cssClasses.imageContainer}>
                  <img src={DiscountImg} alt="Description of the image" />
                </div>
              )}
            <div className={cssClasses.cardFooter}>
              <div className={cssClasses.cardFooterAmount}>
                <div className={cssClasses.amtText}>
                  <span>TOKEN AMOUNT </span>
                  {token.eventTokenId.tokenId.isPriorityPass && (
                    <span className={cssClasses.amount}>
                      ₹{" "}
                      {numberWithCommas(
                        token.amount +
                          (token.upgradedFrom ? token.upgradedFrom.amount : 0)
                      )}
                    </span>
                  )}
                  {!token.eventTokenId.tokenId.isPriorityPass && (
                    <span className={cssClasses.amount}>
                      ₹ {numberWithCommas(token.amount)}
                    </span>
                  )}
                </div>
                {((token.paidAmount > 0 &&
                  !token.eventTokenId.tokenId.isPriorityPass) ||
                  token.eventTokenId.tokenId.isPriorityPass) && (
                  <>
                    <Divider orientation="vertical" flexItem />
                    <div className={cssClasses.amtText}>
                      <>
                        <span>PAID AMOUNT </span>
                        {token.eventTokenId.tokenId.isPriorityPass && (
                          <span className={cssClasses.amount}>
                            ₹{" "}
                            {numberWithCommas(
                              token.paidAmount +
                                (token.upgradedFrom
                                  ? token.upgradedFrom.paidAmount
                                  : 0)
                            )}
                          </span>
                        )}
                        {!token.eventTokenId.tokenId.isPriorityPass && (
                          <span className={cssClasses.amount}>
                            ₹ {numberWithCommas(token.paidAmount)}
                          </span>
                        )}
                      </>
                    </div>
                  </>
                )}
              </div>
              {/* {console.log("token data---->", token)}
              {console.log(timeRemaining, isTimerFinished)}
              {console.log("eventStartDate", eventStartDate)}
              {console.log("eventEndDate", eventEndDate)}
              {console.log("serverClock", serverClock)}
              {console.log(
                "token?.eventId?.EventOnlineBookingConfig[0]",
                token?.eventId?.EventOnlineBookingConfig[0]
              )}
              {console.log("isEventActive", isEventActive)}
              {console.log("token.status", token.status)} */}

              <div
                className={cssClasses.tokenButtonContent}
                style={{ justifyContent: isWrap ? "flex-end" : "" }}
              >
                <div className={cssClasses.tokenConfirmBtnWrap}>
                  {/* If token is active then add book now button for dashboard */}

                  {token.status === "active" &&
                    token?.eventId?.EventOnlineBookingConfig[0]
                      ?.isOnlineBookingAccept === true &&
                    (token?.eventId?.eventId ===
                      "264a13c9-3519-467a-9ecb-3f682334baa1" ||
                      token?.eventId?.eventId ===
                        "e8923af0-3f1e-4525-8dad-d125192c916f") &&
                    serverClock <= eventStartDate &&
                    serverClock <= eventEndDate && (
                      <div
                        className={cssClasses.tokenButtonContent}
                        style={{ justifyContent: "flex-end" }}
                      >
                        <div>
                          {timeRemaining === null ? null : !isTimerFinished ? ( /// {(false)?(
                            <div
                              style={{
                                color: "#fff",
                                backgroundColor: "#1570EF",
                                fontSize: "1.4rem",
                                lineHeight: "2rem",
                                display: "flex",
                                flexDirection: "column",
                                padding: "5px",
                                borderRadius: "5px",
                              }}
                            >
                              <div>Booking Starts In</div>
                              <div>{timeRemaining}</div>
                            </div>
                          ) : (
                            <Button
                              btnName={
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    minWidth: "120px", // ensures consistent width
                                  }}
                                >
                                  {loading ? (
                                    <CircularProgress
                                      size={22}
                                      sx={{ color: "white" }}
                                    />
                                  ) : (
                                    "BOOK NOW"
                                  )}
                                </div>
                              }
                              clicked={handleBooking}
                              disabled={loading}
                              style={{
                                color: "#fff",
                                backgroundColor: "#1570EF",
                                fontSize: "1.4rem",
                                lineHeight: "2rem",
                                fontFamily: "Inter-Medium !important",
                              }}
                            />
                          )}
                        </div>
                      </div>
                    )}

                  {token.status === "active" &&
                    token?.eventId?.EventOnlineBookingConfig[0]
                      ?.isOnlineBookingAccept === true &&
                    (token?.eventId?.eventId ===
                      "8d7e356a-e502-45fb-a170-4628d32f6f8b" ||
                      token?.eventId?.eventId ===
                        "264a13c9-3519-467a-9ecb-3f682334baa1") &&
                    serverClock >= eventStartDate &&
                    serverClock <= eventEndDate && (
                      <div
                        className={cssClasses.tokenButtonContent}
                        style={{ justifyContent: "flex-end" }}
                      >
                        <Button
                          btnName={
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                minWidth: "120px", // ensures consistent width
                              }}
                            >
                              {loading ? (
                                <CircularProgress
                                  size={22}
                                  sx={{ color: "white" }}
                                />
                              ) : (
                                "BOOK NOW"
                              )}
                            </div>
                          }
                          clicked={handleBooking}
                          disabled={loading}
                          style={{
                            color: "#fff",
                            backgroundColor: "#1570EF",
                            fontSize: "1.4rem",
                            lineHeight: "2rem",
                            fontFamily: "Inter-Medium !important",
                          }}
                        />
                      </div>
                    )}

                  {preselectFillKycShown(token) && (
                      <div style={{ display: "flex" }}>
                        <Button
                          btnName={"Fill KYC"}
                          clicked={() => {
                            setCurrentAllotmentPayment(
                              token.allotmentPaymentId
                            );
                            setOpenBookingFormModal(true);
                          }}
                          style={{
                            width: "12rem",
                            color: "#fff",
                            backgroundColor: "rgb(21, 112, 239)",
                            fontSize: "1.4rem",
                            lineHeight: "2rem",
                            fontFamily: "Inter-Medium !important",
                          }}
                        ></Button>
                      </div>
                    )}
                  {token.expiry && (
                    <>
                      {/* {!token.eventTokenId.tokenId.isPreselect && !token.eventTokenId.tokenId.isPriorityPass && ( */}
                      {!token.eventTokenId.tokenId.isPreselect && (
                        <>
                          {/* {token.expiry > Date.now() && token.paidAmount < token.amount && ( */}
                          {((token.paidAmount === 0 &&
                            token.expiry > serverTime) ||
                            (token.paidAmount > 0 &&
                              token.paidAmount < token.amount)) &&
                            !token.status.includes("refund") && (
                              <>
                                <Button
                                  btnName={"Pay Now"}
                                  clicked={() => requireConsent(CONSENT_TYPES.TOKEN, () => {
                                    if (
                                      token.eventTokenId.tokenId.isPriorityPass
                                    ) {
                                      // ! limit is checked based on this token's eventTokenId
                                      setSelectedTokenPaymentData(
                                        token.eventTokenId
                                      );
                                    } else {
                                      setSelectedTokenPaymentData(null);
                                    }
                                    setTokenObj(token);
                                    // if (token.eventTokenId.tokenId.isPreselect) {

                                    setSelectedToken(token);
                                    setOpenTokenPaymentModal(true);
                                    // } else {
                                    //     openTokenPayment(token);
                                    // }
                                  }, { summary: tokenConsentSummary(token) })}
                                  style={{
                                    width:
                                      window.innerWidth > 1366
                                        ? "100%"
                                        : "auto",
                                    color: "#fff",
                                    backgroundColor: "rgb(21, 112, 239)",
                                    fontSize: "1.4rem",
                                    lineHeight: "2rem",
                                    fontFamily: "Inter-Medium !important",
                                    whiteSpace: "nowrap !important",
                                  }}
                                ></Button>
                              </>
                            )}
                        </>
                      )}
                    </>
                  )}
                  {token.eventTokenId.tokenId.isPreselect &&
                    !token.eventTokenId.tokenId.isPriorityPass &&
                    (token.allotmentPaymentId?.status?.includes(
                      "Payment Pending"
                    ) ||
                      token.allotmentPaymentId?.status?.includes(
                        "Partial Payment Done"
                      ) ||
                      token.allotmentPaymentId?.status?.includes(
                        "Preselected"
                      )) && (
                      <>
                        {(token.paidAmount === 0 ||
                          (token.paidAmount > 0 &&
                            token.paidAmount < token.amount)) && (
                          <>
                            <Button
                              btnName={"Pay Now"}
                              disable={preselectPayNowLocked(token)}
                              clicked={() => !preselectPayNowLocked(token) && requireEsign(token.allotmentPaymentId?.allotmentPaymentId, () => requireConsent(CONSENT_TYPES.TOKEN, () => {
                                setTokenObj(token);
                                // if (token.eventTokenId.tokenId.isPreselect) {
                                setSelectedToken(token);
                                setOpenTokenPaymentModal(true);
                                // } else {
                                //     openTokenPayment(token);
                                // }
                              }, { summary: tokenConsentSummary(token) }), { summary: tokenConsentSummary(token) })}
                              style={{
                                width:
                                  window.innerWidth > 1366 ? "100%" : "auto",
                                color: "#fff",
                                backgroundColor: "rgb(21, 112, 239)",
                                fontSize: "1.4rem",
                                lineHeight: "2rem",
                                fontFamily: "Inter-Medium !important",
                              }}
                            ></Button>
                            {preselectPayNowLocked(token) && (
                              <div style={{ fontSize: "1.2rem", color: "#B42318", marginTop: "0.4rem", whiteSpace: "nowrap" }}>
                                {KYC_FIRST_TEXT}
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )}
                </div>
                {token.upgradedFrom && (
                  <div className={cssClasses.tokentokenViewBtnWrap}>
                    {token.upgradedFrom && (
                      <div className={cssClasses.confirmBtnWrap}>
                        <Button
                          btnName={"View Linked Token"}
                          clicked={() => {
                            setTokenObj(token);
                            setOpenLinkedTokenModal(true);
                            // if (token.eventTokenId.tokenId.isPreselect) {
                            // } else {
                            //     openTokenPayment(token);
                            // }
                          }}
                          style={{
                            width: window.innerWidth > 1366 ? "100%" : "100%",
                            color: "#344054",
                            backgroundColor: "#fff",
                            fontSize: "1.4rem",
                            lineHeight: "2rem",
                            fontFamily: "Inter-Medium !important",
                            borderRadius: "8px",
                            border: "1px solid #D0D5DD",
                            boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                            fontWeight: "500",
                          }}
                        ></Button>
                      </div>
                    )}
                  </div>
                )}
                {!isMobileView &&
                  allotment?.status !== "Cancelled" &&
                  !allotment?.status?.includes("Refund") &&
                  // new Date(allotment?.timer) < new Date(serverTime) &&
                  // new Date(allotment?.closeTimer) > new Date(serverTime) &&
                  allotment.showConfirmBtn &&
                  allotment?.preselectConfirmation === "confirmation pending" &&
                  token?.status !== "expired" && (
                    <div className={cssClasses.confirmBtnWrap}>
                      <Button
                        btnName={"Confirm"}
                        clicked={() => {
                          setOpenConfirmationModal(true);
                        }}
                        style={{
                          width: window.innerWidth > 1366 ? "100%" : "auto",
                          color: "#fff",
                          backgroundColor: "rgb(21, 112, 239)",
                          fontSize: "1.4rem",
                          lineHeight: "2rem",
                          fontFamily: "Inter-Medium !important",
                          alignSelf: "flex-end",
                        }}
                      ></Button>
                    </div>
                  )}
              </div>
              {/* {!isMobileView &&
                allotment?.status !== "Cancelled" &&
                new Date(allotment?.timer) < new Date(serverTime) &&
                new Date(allotment?.closeTimer) > new Date(serverTime) &&
                allotment?.preselectConfirmation === "confirmation pending" && (
                  <div className={cssClasses.confirmBtnWrap}>
                    <Button
                      btnName={"Confirm"}
                      clicked={() => {
                        setOpenConfirmationModal(true);
                      }}
                      style={{
                        width: window.innerWidth > 1366 ? "100%" : "auto",
                        color: "#fff",
                        backgroundColor: "rgb(21, 112, 239)",
                        fontSize: "1.4rem",
                        lineHeight: "2rem",
                        fontFamily: "Inter-Medium !important",
                        alignSelf: "flex-end",
                      }}
                    ></Button>
                  </div>
                )} */}
            </div>

            {token.isPrerequisiteAvailable && token.status === "active" && (
              <div className={cssClasses.tokenConfirmBtnWrapPriority}>
                {token.timer && !token.isPrerequisiteUsed && (
                  // <p style={{ fontSize: "1.4rem", fontStyle: "italic" }}>{token.prerequisiteMsg}</p>
                  <div className={cssClasses.timerWrap}>
                    Priority Pass starts at{" "}
                    <MyTimer
                      css={{ fontSize: "1.8rem", color: "#B42318" }}
                      expiryTimestamp={token.timer}
                      onExpire={() => {
                        token.showPPBtn = true;
                        token.timer = null;
                      }}
                    />
                  </div>
                )}
                {!token.isPrerequisiteUsed &&
                  token.timer <= serverTime &&
                  serverTime < token.closeTimer && (
                    // <p style={{ fontSize: "1.4rem", fontStyle: "italic" }}>{token.prerequisiteMsg}</p>
                    <div className={cssClasses.timerWrap}>
                      Expires in{" "}
                      <MyTimer
                        css={{ fontSize: "1.8rem", color: "#B42318" }}
                        expiryTimestamp={token.closeTimer}
                        onExpire={() => {
                          token.showPPBtn = false;
                          token.closeTimer = null;
                          setOpenBuyTokenModal(false);
                        }}
                      />
                    </div>
                  )}
                {/* {token.timer <= new Date().getTime() && !token.isPrerequisiteUsed && */}
                {token.showPPBtn && (
                  <Button
                    btnName={"Buy Priority Pass Now"}
                    clicked={() => {
                      setTokenObj(token);
                      // if (token.eventTokenId.tokenId.isPreselect) {
                      // setSelectedToken(token)
                      setUpgradableTokens(token.upgradableTokens);
                      setPrereqToken(token);
                      setOpenBuyTokenModal(true);
                      setSelectedData(token);
                      // } else {
                      //     openTokenPayment(token);
                      // }
                    }}
                    style={{
                      width: "auto",
                      color: "#fff",
                      backgroundColor: "rgb(21, 112, 239)",
                      fontSize: "1.4rem",
                      lineHeight: "2rem",
                      fontFamily: "Inter-Medium !important",
                    }}
                  ></Button>
                )}
              </div>
            )}
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "0.8rem",
              }}
            >
              {allotment?.status !== "Cancelled" &&
                !allotment?.status?.includes("Refund") &&
                // new Date(allotment?.timer) < new Date(serverTime) &&
                // new Date(allotment.closeTimer) > new Date(serverTime) &&
                allotment.showConfirmBtn &&
                allotment?.preselectConfirmation === "confirmation pending" && (
                  <div className={cssClasses.timerWrap}>
                    {/* Expires in <MyTimer css={{ fontSize: "1.8rem", color: "#98A2B3" }} expiryTimestamp={allotment.closeTimer} */}
                    Expires in{" "}
                    <MyTimer
                      css={{ fontSize: "1.6rem", color: "#E17A00" }}
                      preselectConfirm={true}
                      expiryTimestamp={allotment.closeTimer}
                      svgStyle={{
                        transform: "scale(1.5)",
                      }}
                      onExpire={() => {
                        setOpenConfirmationModal(false);
                      }}
                    />
                  </div>
                )}
              {isMobileView &&
                allotment?.status !== "Cancelled" &&
                // new Date(allotment?.timer) < new Date(serverTime) &&
                // new Date(allotment?.closeTimer) > new Date(serverTime) &&
                allotment.showConfirmBtn &&
                allotment?.preselectConfirmation === "confirmation pending" && (
                  <div className={cssClasses.confirmBtnWrap}>
                    <Button
                      btnName={"Confirm"}
                      clicked={() => {
                        setOpenConfirmationModal(true);
                      }}
                      style={{
                        width: window.innerWidth > 1366 ? "100%" : "auto",
                        color: "#fff",
                        backgroundColor: "rgb(21, 112, 239)",
                        fontSize: "1.4rem",
                        lineHeight: "2rem",
                        fontFamily: "Inter-Medium !important",
                        alignSelf: "flex-end",
                      }}
                    ></Button>
                  </div>
                )}
            </div>

            {allotment.status !== "Cancelled" &&
              allotment.status !== "Refund Processed" &&
              allotment.status !== "Released" &&
              allotment.status !== "Refund Initiated" && (
                <div className={cssClasses.paymentText}>
                  {allotment?.paidAmount < allotment?.paymentId?.amount ? (
                    <>
                      <p
                        style={{
                          fontSize: "1.4rem",
                          fontStyle: "italic",
                          color: "red",
                        }}
                      >
                        Please complete payment!
                      </p>
                    </>
                  ) : (
                    <>
                      {allotment.showMsg &&
                      !allotment.showConfirmBtn &&
                      allotment.preselectConfirmation ===
                        "confirmation pending" &&
                      !allotment.isExpired ? (
                        <>
                          <p
                            style={{ fontSize: "1.4rem", fontStyle: "italic" }}
                          >
                            Preselect Confirmations will start from{" "}
                            <b>
                              {new Date(
                                allotment?.paymentId?.eventTokenId.eventId.preselectConfirmationConfig.startDateTime
                              ).toDateString()}{" "}
                              {new Date(
                                allotment?.paymentId?.eventTokenId.eventId.preselectConfirmationConfig.startDateTime
                              ).toLocaleTimeString()}
                            </b>
                          </p>
                        </>
                      ) : !allotment.showConfirmBtn &&
                        !allotment.showMsg &&
                        allotment?.preselectConfirmation ===
                          "confirmation pending" &&
                        !allotment.isExpired ? (
                        <>
                          <p
                            style={{ fontSize: "1.4rem", fontStyle: "italic" }}
                          >
                            Preselect Confirmations will start soon!
                          </p>
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </div>
              )}
          </Card>
        )}
        {consentModal}
        {esignModal}
        {openTokenPaymentModal && (
          <TokenPayment
            payableTokenData={selectedTokenPaymentData}
            open={openTokenPaymentModal}
            tokenPaymentResponse={updateTokenTables}
            tokenDetails={selectedToken}
            handleClose={() => {
              setOpenTokenPaymentModal(false);
              setSelectedToken(null);
            }}
            handleOpenPaymentGatewaySelectionModal={handleOpenPaymentGatewaySelectionModal}
          />
        )}
        {openPaymentGatewaySelectionModal && (
         <PaymentGatewaySelection
                      open={openPaymentGatewaySelectionModal}
                      onClose={() => {
                        setOpenPaymentGatewaySelectionModal(false);
                        setOpenTokenPaymentModal(false);
                        setSelectedToken(null);
                      }}
                      selectedToken={selectedToken}
                      tokenPaymentResponse={updateTokenTables}
                      payableTokenData={selectedTokenPaymentData}
                      payableAmount={selectedPayableAmount}
                      type={"token"}
                  />
        )}

        {openBuyTokenModal && (
          <BuyToken
            open={openBuyTokenModal}
            handleClose={() => {
              setOpenBuyTokenModal(false);
            }}
            availableTokens={upgradableTokens}
            tokenSelectionResponse={(token) => {
              setSelectedTokenPaymentData(token);
              // addTokenPayment(token);
              // !vedashree changes
              addPriorityPasstoken(token);
              // ! gaurav changes
              // presentLoader();
              // let obj = {
              //   token: token,
              //   leadId: selectedLead.leadId,
              //   paymentId: prereqToken.paymentId
              // }
              // setTokenObj(selectedData);
              // setSelectedToken(selectedData);

              // dismissLoader()
              // ! sarita changes
              // ${process.env.REACT_APP_PAYMENT_LINK_URL}
              // axios.post(` ${process.env.REACT_APP_PAYMENT_LINK_URL}priorityPass/enqueue`, obj).then((resp) => {
              //
              //   //  let abc = setInterval(async () => {
              //   //   await getQueueStatus(resp).then((response)=>{
              //   //
              //   //   if (response.data.status === 'complete'){
              //   //     dismissLoader();
              //   //     clearInterval(abc);
              //   //     if(!response.data.success){
              //   //
              //   //       errorTost(`You cannot buy ${token?.tokenId?.name} now as the limit has exceeded!`);
              //   //     }
              //   //   }
              //   //   }).catch((err)=>{
              //   //
              //   //   });
              //   //  }, 1000);
              //   // ??Recursive calls until we get response as res.data.status === 'complete'
              //   // getQueueStatusRecursive(resp, token?.tokenId?.name);
              //   dismissLoader()
              // }).catch((err) => {
              //   dismissLoader();
              //
              // });
            }}
          />
        )}
        {openLinkedTokenModal && (
          <LinkedToken
            open={openLinkedTokenModal}
            handleClose={() => {
              setOpenLinkedTokenModal(false);
            }}
            selectedToken={tokenObj}
          />
        )}
        {openConfirmationModal && (
          <PreselectConfirmation
            allotmentDetails={allotment}
            open={openConfirmationModal}
            handleClose={() => setOpenConfirmationModal(false)}
            returnResp={UpdatePreselectUpdate}
          />
        )}
        {openCong && (
          <Congratulation
            open={openCong}
            handleClose={() => setOpenCong(false)}
            time={8000}
          />
        )}
        {openBookingFormModal && (
          <BookingForm
            allotment={currentAllotmentPayment}
            open={openBookingFormModal}
            handleClose={() => {
              setOpenBookingFormModal(false);
            }}
          />
        )}
      </div>
    </>
  );
};

export default Token;

// /* eslint-disable react-hooks/exhaustive-deps */
// import { Card, CircularProgress, Divider, useMediaQuery } from "@mui/material";
// import React, { useEffect, useRef, useState } from "react";
// import ReactTimeAgo from "react-time-ago";
// import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
// import Dot from "../Icons/Dot";
// import cssClasses from "./Home.module.css";
// import TimeAgo from "javascript-time-ago";
// import en from "javascript-time-ago/locale/en.json";
// import Button from "../../Subcomponents/Button";
// import TokenIcon from "../../Assets/Images/Token/token.svg";
// import BoughtOnIcon from "../../Assets/Images/Token/boughton.svg";
// import ValidTillIcon from "../../Assets/Images/Token/valid.svg";
// import TokenPayment from "../../Modals/TokenPayment/TokenPayment";
// import { dismissLoader, presentLoader } from "../../Services/loader";
// import { errorTost, successTost } from "../../Services/Toast";
// import {
//   getPreselectPaymentConfig,
//   createTokenPaymentLink,
//   getTokenPaymentLink,
//   eventTokenPaymentLink,
//   priorityPassToken,
//   getTokenServerTime,
// } from "../../Services/Tokens";
// import {
//   createPaymentOrder,
//   getPaymentPlansPriceFromServer,
//   getPreselectConfirmationsConfig,
//   getPyamentLink,
//   sdrPaymentMode,
// } from "../../Services/Allotment";
// import MyTimer from "../../Subcomponents/Timer";
// import LinkedToken from "../../Modals/LinkedToken/LinkedToken";
// import { useSelector } from "react-redux";
// import BuyToken from "../../Modals/BuyToken/BuyToken";
// import PreselectConfirmation from "../../Modals/PreselectConfirmation/PreselectConfirmation";
// import BookingForm from "../../Modals/BookingForm/BookingForm";
// import { supabase } from "../../supabaseClient";
// import {
//   numberWithCommas,
//   tokenPaymentComplete,
// } from "../../Assets/Common/CommonFunctions";
// import DiscountImg from "../../Assets/Images/Common/disountImg.PNG";
// import Congratulation from "../../Modals/PreselectConfirmation/Congratulation";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import * as actionTypes from "../../Redux Store/actionType/action-type";

// const Token = ({
//   token,
//   serverTime: _serverTime,
//   allotment: _allotment,
//   updatedRecord = [],
//   handleUpdateRecord,
// }) => {
//   let loggedInUser = {};
//   loggedInUser = useSelector((state) => state.Auth.user);
//   TimeAgo.setDefaultLocale(en.locale);
//   TimeAgo.addLocale(en);
//   const navigate = useNavigate();
//   const [allotment, set_Allotment] = useState({ ..._allotment } || {});
//   const [serverTime, setServerTime] = useState(_serverTime || "");
//   const [selectedToken, setSelectedToken] = useState(token);
//   const [openTokenPaymentModal, setOpenTokenPaymentModal] = useState(false);
//   const [openLinkedTokenModal, setOpenLinkedTokenModal] = useState(false);
//   const [tokenObj, setTokenObj] = useState({});
//   const [selectedTokenPaymentData, setSelectedTokenPaymentData] =
//     useState(null);
//   const selectedLead = JSON.parse(localStorage.getItem("selectedLead"));
//   const [openBuyTokenModal, setOpenBuyTokenModal] = useState(false);
//   const [upgradableTokens, setUpgradableTokens] = useState([]);
//   const [prereqToken, setPrereqToken] = useState(null);
//   const [selectedData, setSelectedData] = useState(null);
//   const [message, setMessage] = useState("");
//   const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
//   const [openCong, setOpenCong] = useState(false);
//   const [fastbooking, setFastBooking] = useState(false); // for adding book now button for fastbooking
//   const isMobileView = useMediaQuery("(max-width:720px)");
//   const [currentAllotmentPayment, setCurrentAllotmentPayment] = useState();
//   const [openBookingFormModal, setOpenBookingFormModal] = useState(false);
//   const isWrap = useMediaQuery("(max-width:1440px)");
//   const timeoutId1 = useRef(null);
//   const msgTimeoutId1 = useRef(null);
//   const timeoutId2 = useRef(null);
//   const msgTimeoutId2 = useRef(null);
//   const [updatedUnitCost, setUpdatedUnitCost] = useState({
//     bsp: "",
//     gst: "",
//     sdr: "",
//     total: "",
//   });
//   const expiretimeoutId = useRef(null);
//   const dispatch = useDispatch();

//   const getServerTime = async () => {
//     getTokenServerTime()
//       .then((res) => {
//         console.log("server Time==>", res?.data?.currentTime, serverTime);
//         setServerTime(res?.data?.currentTime);
//       })
//       .catch((error) => {
//         console.log("err in getQueueStatus api call", error);
//       });
//   };

//   useEffect(() => {
//     let newAllotment = { ..._allotment };
//     getTokenServerTime()
//       .then((res) => {
//         setServerTime(res?.data?.currentTime);
//         const time = res?.data?.currentTime;
//         if (allotment?.launchId) {
//           getPreselectConfirmationsConfig(
//             newAllotment?.paymentId?.eventId,
//             newAllotment?.paymentId?.eventTokenId?.eventTokenId,
//             newAllotment?.launchId
//           )
//             .then((val) => {
//               newAllotment.showConfirmBtn = false;
//               newAllotment.showMsg = false;
//               newAllotment.isExpired = false;
//               // dismissLoader();
//               newAllotment.discountPercentage =
//                 val?.data?.length > 0 ? val?.data[0]?.priceDiscount : 0;
//               newAllotment.showPreselectPrices =
//                 val?.data?.length > 0 ? val?.data[0]?.showPreselectPrices : [];

//               newAllotment.paymentId.eventTokenId.eventId.preselectConfirmationConfig =
//                 val?.data?.length > 0
//                   ? val?.data[0]?.preselectConfirmationConfig
//                   : newAllotment.paymentId.eventTokenId.eventId
//                       .preselectConfirmationConfig;
//               if (
//                 newAllotment.paymentId?.eventTokenId?.eventId
//                   ?.preselectConfirmationConfig?.endDateTime -
//                   Date.now() <=
//                 parseInt(
//                   newAllotment.paymentId?.eventTokenId?.eventId
//                     ?.preselectConfirmationConfig?.timer
//                 ) *
//                   60000
//               ) {
//                 newAllotment.expiry =
//                   newAllotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.endDateTime;
//                 getServerTime();
//               } else {
//                 console.log("expiry", false);
//               }
//               if (
//                 val?.data?.length > 0
//                   ? val?.data[0]?.preselectConfirmationConfig?.startDateTime
//                   : newAllotment?.paymentId?.eventTokenId?.eventId
//                       ?.preselectConfirmationConfig?.startDateTime > time
//               ) {
//                 clearTimeout(timeoutId2.current);
//                 clearTimeout(timeoutId1.current);
//                 timeoutId1.current = setTimeout(() => {
//                   set_Allotment({
//                     ..._allotment,
//                     showPreselectPrices:
//                       val?.data?.length > 0
//                         ? val?.data[0]?.showPreselectPrices
//                         : [],
//                     closeTimer:
//                       val?.data?.length > 0
//                         ? val?.data[0]?.preselectConfirmationConfig?.endDateTime
//                         : newAllotment?.paymentId?.eventTokenId?.eventId
//                             ?.preselectConfirmationConfig?.endDateTime,
//                     timer:
//                       val?.data?.length > 0
//                         ? val?.data[0]?.preselectConfirmationConfig
//                             ?.startDateTime
//                         : newAllotment.paymentId?.eventTokenId?.eventId
//                             ?.preselectConfirmationConfig?.startDateTime,
//                     showConfirmBtn: true,
//                     showMsg: false,
//                   });
//                 }, newAllotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.startDateTime - time);
//                 clearTimeout(expiretimeoutId.current);
//                 expiretimeoutId.current = setTimeout(() => {
//                   set_Allotment({
//                     ..._allotment,
//                     showPreselectPrices:
//                       val?.data?.length > 0
//                         ? val?.data[0]?.showPreselectPrices
//                         : [],
//                     closeTimer:
//                       val?.data?.length > 0
//                         ? val?.data[0]?.preselectConfirmationConfig?.endDateTime
//                         : newAllotment?.paymentId?.eventTokenId?.eventId
//                             ?.preselectConfirmationConfig?.endDateTime,
//                     timer:
//                       val?.data?.length > 0
//                         ? val?.data[0]?.preselectConfirmationConfig
//                             ?.startDateTime
//                         : newAllotment.paymentId?.eventTokenId?.eventId
//                             ?.preselectConfirmationConfig?.startDateTime,
//                     showConfirmBtn: false,
//                     showMsg: false,
//                     isExpired: true,
//                   });
//                 }, newAllotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.endDateTime - time);
//                 if (
//                   val?.data?.length > 0 &&
//                   val?.data[0]?.preselectConfirmationConfig?.startDateTime >
//                     time &&
//                   newAllotment.preselectConfirmation === "confirmation pending"
//                 ) {
//                   clearTimeout(msgTimeoutId2.current);
//                   clearTimeout(msgTimeoutId1.current);
//                   msgTimeoutId1.current = setTimeout(() => {
//                     set_Allotment({
//                       ..._allotment,
//                       showPreselectPrices:
//                         val?.data?.length > 0
//                           ? val?.data[0]?.showPreselectPrices
//                           : [],
//                       showMsg: true,
//                       showConfirmBtn: false,
//                     });
//                   }, newAllotment?.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.startDateTime - newAllotment?.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.timer * 60000 - time);
//                 }
//               } else {
//                 newAllotment.timer =
//                   val?.data?.length > 0
//                     ? val?.data[0]?.preselectConfirmationConfig?.startDateTime
//                     : newAllotment.paymentId?.eventTokenId?.eventId
//                         ?.preselectConfirmationConfig?.startDateTime;
//                 newAllotment.closeTimer =
//                   val?.data?.length > 0
//                     ? val?.data[0]?.preselectConfirmationConfig?.endDateTime
//                     : newAllotment.paymentId?.eventTokenId?.eventId
//                         ?.preselectConfirmationConfig?.endDateTime;
//               }
//             })
//             .catch((err) => {});
//         } else {
//           newAllotment.showConfirmBtn = false;
//           newAllotment.showMsg = false;
//           newAllotment.discountPercentage = 0;
//           newAllotment.showCost = [];
//           if (
//             newAllotment.paymentId?.eventTokenId?.eventId
//               ?.preselectConfirmationConfig?.endDateTime -
//               Date.now() <=
//             parseInt(
//               newAllotment.paymentId?.eventTokenId?.eventId
//                 ?.preselectConfirmationConfig?.timer
//             ) *
//               60000
//           ) {
//             newAllotment.expiry =
//               newAllotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.endDateTime;
//           } else {
//             console.log("expiry", false);
//           }
//           if (
//             newAllotment.paymentId?.eventTokenId?.eventId
//               ?.preselectConfirmationConfig?.startDateTime >
//             new Date().getTime()
//           ) {
//             setTimeout(() => {
//               set_Allotment({
//                 ..._allotment,
//                 closeTimer:
//                   newAllotment.paymentId?.eventTokenId?.eventId
//                     ?.preselectConfirmationConfig?.endDateTime,
//                 timer:
//                   newAllotment.paymentId?.eventTokenId?.eventId
//                     ?.preselectConfirmationConfig?.startDateTime,
//                 showConfirmBtn: true,
//               });
//             }, newAllotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.startDateTime - new Date().getTime());
//           } else {
//             newAllotment.timer = newAllotment.paymentId?.eventTokenId?.eventId
//               ?.preselectConfirmationConfig
//               ? newAllotment.paymentId?.eventTokenId?.eventId
//                   ?.preselectConfirmationConfig?.startDateTime
//               : null;
//             newAllotment.closeTimer = newAllotment.paymentId?.eventTokenId
//               ?.eventId?.preselectConfirmationConfig
//               ? newAllotment.paymentId?.eventTokenId?.eventId
//                   ?.preselectConfirmationConfig?.endDateTime
//               : null;
//           }
//         }
//       })
//       .catch((error) => {
//         console.log("err in getQueueStatus api call", error);
//       });
//     set_Allotment({ ...newAllotment });
//   }, [handleUpdateRecord]);
//   useEffect(() => {
//     const handleRecordUpdated = updatedRecord.find(
//       (token) =>
//         token?.new?.launchId === allotment?.launchId &&
//         token.new.eventId === allotment?.paymentId?.eventId &&
//         token.new.eventTokenId ===
//           allotment?.paymentId?.eventTokenId?.eventTokenId
//     );
//     if (handleRecordUpdated) {
//       getTokenServerTime()
//         .then((res) => {
//           setServerTime(res?.data?.currentTime);
//           setnewConfig(handleRecordUpdated, res?.data?.currentTime);
//         })
//         .catch((error) => {
//           console.log("err in getQueueStatus api call", error);
//         });
//     }
//   }, [updatedRecord]);
//   useEffect(() => {
//     if (_allotment?.paymentPlanId) {
//       getPaymentPlansPriceFromServer(
//         _allotment?.paymentPlanId,
//         _allotment?.unitId?.unitId
//       )
//         .then((planResp) => {
//           if (planResp?.data[0]) {
//             setUpdatedUnitCost({
//               bsp: planResp.data[0]?.BSP,
//               gst: planResp.data[0]?.GST,
//               sdr: planResp.data[0]?.SDR,
//               total: planResp.data[0]?.totalCost,
//             });
//           } else {
//             setUpdatedUnitCost({
//               bsp: _allotment?.unitId?.BSP,
//               gst: _allotment?.unitId?.GST,
//               sdr: _allotment?.unitId?.SDR,
//               total: _allotment?.unitId?.totalCost,
//             });
//           }
//         })
//         .catch((err) => {
//           setUpdatedUnitCost({
//             bsp: _allotment?.unitId?.BSP,
//             gst: _allotment?.unitId?.GST,
//             sdr: _allotment?.unitId?.SDR,
//             total: _allotment?.unitId?.totalCost,
//           });
//           errorTost("Error While getting Payment Plan Details.");
//           console.log(err.message);
//         });
//     } else {
//       setUpdatedUnitCost({
//         bsp: _allotment?.unitId?.BSP,
//         gst: _allotment?.unitId?.GST,
//         sdr: _allotment?.unitId?.SDR,
//         total: _allotment?.unitId?.totalCost,
//       });
//     }
//   }, [_allotment]);
//   const setnewConfig = (newConfigData, time = serverTime) => {
//     let newAllotment = { ..._allotment };
//     newAllotment.showConfirmBtn = false;
//     newAllotment.showMsg = false;
//     newAllotment.isExpired = false;
//     newAllotment.showPreselectPrices = newConfigData.new.showPreselectPrices;
//     newAllotment.paymentId.eventTokenId.eventId.preselectConfirmationConfig =
//       newConfigData?.new?.preselectConfirmationConfig;

//     if (
//       newAllotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig
//         ?.endDateTime -
//         Date.now() <=
//       parseInt(
//         newAllotment.paymentId?.eventTokenId?.eventId
//           ?.preselectConfirmationConfig?.timer
//       ) *
//         60000
//     ) {
//       console.log("expiry", true);
//       newAllotment.expiry =
//         newAllotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.endDateTime;
//       console.log("newAllotment.expiry: ", newAllotment.expiry);
//       getServerTime();
//     } else {
//       console.log("expiry", false);
//     }
//     if (
//       newConfigData.new.preselectConfirmationConfig?.startDateTime > time ||
//       time < newConfigData.new.preselectConfirmationConfig?.endDateTime
//     ) {
//       clearTimeout(timeoutId1.current);
//       clearTimeout(timeoutId2.current);
//       timeoutId2.current = setTimeout(() => {
//         set_Allotment({
//           ..._allotment,
//           showPreselectPrices: newConfigData.new.showPreselectPrices,
//           closeTimer:
//             newConfigData.new.preselectConfirmationConfig?.endDateTime,
//           timer: newConfigData.new.preselectConfirmationConfig?.startDateTime,
//           showConfirmBtn: true,
//           showMsg: false,
//         });
//       }, newConfigData.new.preselectConfirmationConfig?.startDateTime - time);
//       clearTimeout(expiretimeoutId.current);
//       expiretimeoutId.current = setTimeout(() => {
//         set_Allotment({
//           ..._allotment,
//           showPreselectPrices: newConfigData.new.showPreselectPrices,
//           closeTimer:
//             newConfigData.new.preselectConfirmationConfig?.endDateTime,
//           timer: newConfigData.new.preselectConfirmationConfig?.startDateTime,
//           showConfirmBtn: false,
//           showMsg: false,
//           isExpired: true,
//         });
//       }, newConfigData.new.preselectConfirmationConfig?.endDateTime - time);
//       if (
//         newConfigData.new.preselectConfirmationConfig?.startDateTime > time &&
//         newAllotment.preselectConfirmation === "confirmation pending"
//       ) {
//         clearTimeout(msgTimeoutId1.current);
//         clearTimeout(msgTimeoutId2.current);
//         msgTimeoutId2.current = setTimeout(() => {
//           set_Allotment({
//             ..._allotment,
//             showPreselectPrices: newConfigData.new.showPreselectPrices,
//             showMsg: true,
//             showConfirmBtn: false,
//           });
//         }, newAllotment?.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.startDateTime - newAllotment?.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.timer * 60000 - time);
//       }
//     }
//     set_Allotment({ ...newAllotment });
//   };

//   function UpdatePreselectUpdate(respValue) {
//     if (respValue === true) {
//       setOpenCong(true);
//     }
//   }

//   async function updateTokenTables(amt) {
//     presentLoader();
//     setOpenTokenPaymentModal(false);
//     // !todo 1. check if token is preselect
//     // !todo 2. if preselect, get payment settings from event settings
//     // !todo 3. if not preselect, get payment settings from settings tab
//     if (selectedToken.eventTokenId.tokenId.isPreselect) {
//       getPreselectPaymentConfig(selectedToken.eventId.eventId)
//         .then(async (config) => {
//           if (config[0].preselectPaymentModes.includes("Customer In-App")) {
//             const obj = {
//               transactionObj: {
//                 transactionType: "preselect",
//                 modeOfPayment: "Razorpay-Customer Portal",
//                 allotmentPaymentId:
//                   selectedToken.allotmentPaymentId?.allotmentPaymentId,
//                 unitId: selectedToken?.allotmentPaymentId?.unitId?.unitId,
//                 inventoryMergeId:
//                   selectedToken?.allotmentPaymentId?.inventoryMergedId
//                     ?.inventoryMergeId,
//                 leadId: selectedToken.leadId,
//                 status: "pending",
//                 amount: amt,
//               },
//               amount: amt,
//               type: "Allotment",
//             };
//             await createPaymentOrder(obj)
//               .then(async (order) => {
//                 if (order?.data?.success) {
//                   dismissLoader();
//                   const options = {
//                     key: process.env.REACT_APP_RAZOR_PAY_KEY,
//                     amount: amt * 100,
//                     currency: "INR",
//                     name: "VJ Developers",
//                     partial_payment: true,
//                     description:
//                       "Payment for token " + selectedToken.tokenNumber,
//                     order_id: order.data.id,
//                   };
//                   const rzp1 = new window.Razorpay(options);
//                   rzp1.open();
//                 } else if (order?.data?.message) {
//                   console.log("message", message);
//                   dismissLoader();
//                   errorTost(order?.data?.message);
//                 } else {
//                   dismissLoader();
//                   errorTost("Couldn't create order! please try again later");
//                 }
//               })
//               .catch((err) => {
//                 console.log("err: ", err);
//                 dismissLoader();
//                 errorTost("Network Error. Please try again later!");
//               });
//           } else if (config[0].preselectPaymentModes.includes("Razorpay")) {
//             await createTokenPaymentLink(amt, "allotment", selectedToken)
//               .then((create) => {
//                 if (create.data.success) {
//                   getTokenPaymentLink(create.data.paymentLinkId)
//                     .then((resp) => {
//                       if (resp.data) {
//                         setSelectedToken(null);
//                         successTost(
//                           "Payment link sent on registered mobile number!"
//                         );
//                         let anchor = document.createElement("a");
//                         anchor.href = resp.data.link;
//                         anchor.target = "_blank";
//                         anchor.click();
//                         dismissLoader();
//                       } else {
//                         dismissLoader();
//                         errorTost(
//                           "Create Payment Failed! Please try again later"
//                         );
//                       }
//                     })
//                     .catch((err) => {
//                       console.log("err: ", err);
//                       dismissLoader();
//                       errorTost("Network Error. Please try again later!");
//                     });
//                 } else {
//                   dismissLoader();
//                   errorTost("Couldn't create order! please try again later");
//                 }
//               })
//               .catch((err) => {
//                 console.log("Error", err);
//                 errorTost("Create Payment Failed! Please try again later");
//               });
//           }
//         })
//         .catch((err) => {
//           console.log("Error", err);
//           errorTost(
//             "Error While getting Preselect Details! Please try again later"
//           );
//         });
//     } else {
//       sdrPaymentMode()
//         .then(async (resp) => {
//           // const currentDate = new Date();
//           if (resp.data[0].useLinkInCustomerAppForToken) {
//             eventTokenPaymentLink(amt, selectedToken).then((create) => {
//               if (create.data.success) {
//                 getPyamentLink(create.data.paymentLinkId)
//                   .then((resp) => {
//                     if (resp.data) {
//                       setSelectedToken(null);
//                       successTost(
//                         "Payment link sent on registered mobile number!"
//                       );
//                       let anchor = document.createElement("a");
//                       anchor.href = resp.data.link;
//                       anchor.target = "_blank";
//                       anchor.click();
//                       dismissLoader();
//                     } else {
//                       dismissLoader();
//                       errorTost(
//                         "Couldn't create order! please try again later"
//                       );
//                     }
//                   })
//                   .catch((err) => {
//                     dismissLoader();
//                     console.log(
//                       "Couldn't create order! please try again later"
//                     );
//                   });
//               } else {
//                 dismissLoader();
//                 errorTost(create.data.message);
//               }
//             });
//           } else {
//             const obj = {
//               amount: amt,
//               type: "Token",
//               transactionObj: {
//                 eventTokenId: selectedToken.eventTokenId.eventTokenId,
//                 paymentId: selectedToken.paymentId,
//                 leadId: selectedToken.leadId,
//                 status: "pending",
//                 amount: amt,
//               },
//             };
//             await createPaymentOrder(obj)
//               .then(async (order) => {
//                 if (order?.data?.success) {
//                   dismissLoader();
//                   const options = {
//                     key: process.env.REACT_APP_RAZOR_PAY_KEY, // Enter the Key ID generated from the Dashboard
//                     // amount: token.eventTokenId.tokenId.isPreselect ? 50000000 : (token.amount - token.paidAmount) * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
//                     // ? token amount for preselect token as well
//                     // ! vedashree to change this amount
//                     amount: amt * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
//                     currency: "INR",
//                     name: "VJ Developers",
//                     partial_payment: true,
//                     description:
//                       "Payment for token " + selectedToken.tokenNumber,
//                     order_id: order.data.id,
//                   };

//                   const rzp1 = new window.Razorpay(options);
//                   // rzp1.on("payment.failed", function (response) {
//                   // 	// ?todo: show loader modal
//                   // });
//                   rzp1.open();
//                 } else {
//                   dismissLoader();
//                   errorTost("Token limit exceeded.");
//                 }
//               })
//               .catch((err) => {
//                 console.log("err: ", err);
//                 dismissLoader();
//                 errorTost("Network Error. Please try again later!");
//               });
//           }
//         })
//         .catch((err) => {
//           console.log("err: ", err);
//           dismissLoader();
//           errorTost("Network Error. Please try again later!");
//         });
//     }
//   }

//   function addPriorityPasstoken(ppTokenData) {
//     presentLoader();
//     const ppObj = {
//       eventTokenId: ppTokenData,
//       gtPaymentId: prereqToken.paymentId,
//       leadId: selectedLead.leadId,
//       paidAmount: 0,
//       amount: ppTokenData.tokenId.amount,
//       TokenTransactions: [],
//     };

//     setSelectedToken(ppObj);
//     priorityPassToken(ppObj)
//       .then((ppResp) => {
//         if (ppResp?.data?.success?.length > 0) {
//           setSelectedToken((pre) => {
//             pre.paymentId = ppResp.data.success[0].paymentId;
//             return { ...pre };
//           });
//           dismissLoader();
//           setOpenBuyTokenModal(false);
//           setOpenTokenPaymentModal(true);
//         } else {
//           errorTost("Try again in sometime!");
//           dismissLoader();
//         }
//       })
//       .catch((err) => {
//         console.log("err: ", err);
//         dismissLoader();
//         errorTost("Network Error. Please try again later!");
//       });
//   }
//   function arrayContains(key, arr) {
//     return arr.indexOf(key) > -1;
//   }

//     //timer for diwali 2025 launch
// // timer for diwali 2025 launch
// // ✅ Server-synced timer for Diwali 2025 launch
// const [serverClock, setServerClock] = useState(null);
// const [offset, setOffset] = useState(0);

// // 1️⃣ Fetch server time from backend
// const FetchServerTime = async () => {
//   try {
//     const res = await getTokenServerTime();
//     const serverUTC = new Date(res?.data?.currentTime).getTime();
//     const localNow = Date.now();
//     setServerClock(serverUTC);
//     setOffset(localNow - serverUTC); // difference between local and server clock
//   } catch (error) {
//     console.log("Error fetching server time:", error);
//   }
// };

// // 2️⃣ Fetch immediately + refresh every 5 minutes
// useEffect(() => {
//   FetchServerTime();
//   const interval = setInterval(getServerTime, 5 * 60 * 1000);
//   return () => clearInterval(interval);
// }, []);

// // 3️⃣ Diwali Launch Date
// // const eventDate = "2025-10-28T16:10:00"; // yyyy-mm-ddThh:mm:ss

// const [eventDate, setEventDate] = useState(null);
//  const [timeRemaining, setTimeRemaining] = useState("Loading...");
//   const [isTimerFinished, setIsTimerFinished] = useState(false);

//  // Fetch event start date when token changes
// useEffect(() => {
//   const fetchEventStartDate = async () => {
//     try {
//       const body = { eventId: token?.eventId?.eventId };
//       const res = await axios.post(
//         `${process.env.REACT_APP_PAYMENT_LINK_URL}customerOnlineBooking/getEventOnlineBookingConfigDetails`,
//         body
//       );
//       const startDate = res?.data?.data?.startDate;
//       console.log('Fetched Start Date:', startDate);  // Log the fetched startDate from the API

//       if (startDate) {
//         const iso = new Date(startDate).toISOString();
//         setEventDate(iso);

//         // Check if eventDate is equal to startDate
//         if (iso === eventDate) {
//           console.log("Event Date and Start Date are equal.");
//         } else {
//           console.log("Event Date and Start Date are NOT equal.");
//         }
//       } else {
//         console.warn("No Startdate found in response");
//       }
//     } catch (error) {
//       console.error("Error fetching event start date:", error);
//     }
//   };

//   if (token?.eventId?.eventId) {
//     fetchEventStartDate();
//   }
// }, [token, eventDate]);  // Depend on token and eventDate to rerun the effect if they change
// console.log('EventDate', eventDate)

//   // Calculate time remaining
//   useEffect(() => {
//     const computeRemaining = () => {
//       if (!serverClock || !eventDate) return { finished: false, text: "Loading..." };

//       const now = Date.now() - offset; // Simulate server time
//       const diff = new Date(eventDate).getTime() - now;

//       if (diff <= 0) return { finished: true, text: "0d : 0hrs : 0min : 0s" };

//       const days = Math.floor(diff / (1000 * 60 * 60 * 24));
//       const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//       const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
//       const seconds = Math.floor((diff % (1000 * 60)) / 1000);

//       return {
//         finished: false,
//         text: `${days}d : ${hours}hrs : ${minutes}min : ${seconds}s`,
//       };
//     };

//     const initial = computeRemaining();
//     setTimeRemaining(initial.text);
//     setIsTimerFinished(initial.finished);

//     const updateTimer = () => {
//       const updated = computeRemaining();
//       setTimeRemaining(updated.text);
//       setIsTimerFinished(updated.finished);
//     };

//     const interval = setInterval(updateTimer, 1000);
//     return () => clearInterval(interval);
//   }, [serverClock, eventDate, offset]);

//    const isBookingAvailable = eventDate && serverClock && new Date(eventDate).getTime() > serverClock;

//   const [loading, setLoading] = useState(false);

//   const handleBooking = async () => {
//     setLoading(true);
//     try {
//       const res = await axios.post(
//         `${process.env.REACT_APP_PAYMENT_LINK_URL}customerOnlineBooking/getAllUnitsFromLaunchesForCustomerFastBooking`
//       );

//       if (res.data?.data) {
//         navigate("/Home/UnitFloorMap", {
//           state: { data: res.data.data, paymentId: token?.paymentId ,tokenNo:token?.tokenNumber},
//         });
//       }
//     } catch (error) {
//       console.error("Error fetching units:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   return (
//     <>
//       <div>
//         {token && (
//           <Card
//             className={cssClasses.tokenEventWrap}
//             style={{ borderRadius: "20px", boxShadow: "none" }}
//           >
//             <div className={cssClasses.tokenCardHeader}>
//               <div className={cssClasses.tokenCardHeaderSection}>
//                 <div>
//                   <img src={TokenIcon} alt="token" />
//                 </div>
//                 <div>
//                   <div>
//                     {token.paidAmount === token.amount && (
//                       <div className={cssClasses.tokenNumWrap}>
//                         <span>VJ{token.tokenNumber}</span>
//                       </div>
//                     )}
//                     <div className={cssClasses.tokenDataShow}>
//                       <div className={cssClasses.tokenNoData}>
//                         <span className={cssClasses.tokenNoData}>
//                           {token.eventTokenId.tokenId.name}
//                         </span>
//                       </div>
//                     </div>

//                     {token.eventTokenId.tokenId.isPreselect && (
//                       <span style={{ fontSize: "1.4rem" }}>Preselect</span>
//                     )}
//                   </div>
//                   <div className={cssClasses.tokenStatus}>
//                     {token.status === "pending" && (
//                       <LeadStatusChip
//                         label={token.status}
//                         icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
//                         style={{
//                           color: "#B42318",
//                           backgroundColor: "#FEF3F2",
//                         }}
//                       ></LeadStatusChip>
//                     )}
//                     {token.status === "partial" && (
//                       <LeadStatusChip
//                         label={token.status}
//                         icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
//                         style={{
//                           color: "#B42318",
//                           backgroundColor: "#FEF3F2",
//                         }}
//                       ></LeadStatusChip>
//                     )}
//                     {token.status === "active" && (
//                       <LeadStatusChip
//                         label={token.status}
//                         icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
//                         style={{
//                           color: "#027A48",
//                           backgroundColor: "#ECFDF3",
//                         }}
//                       ></LeadStatusChip>
//                     )}
//                     {token.status === "alloted" && (
//                       <LeadStatusChip
//                         label={
//                           token.eventTokenId.tokenId.isPreselect
//                             ? "Preselected"
//                             : token.status
//                         }
//                         icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
//                         style={{
//                           color: "#C11574",
//                           backgroundColor: "#FDF2FA",
//                         }}
//                       />
//                     )}

//                     {(token.status === "refund requested" ||
//                       token.status === "Upgraded" ||
//                       token.status === "refund initiated") && (
//                       <LeadStatusChip
//                         label={token.status}
//                         icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
//                         style={{
//                           color: "#B54708",
//                           backgroundColor: "#FFFAEB",
//                         }}
//                       ></LeadStatusChip>
//                     )}
//                     {(token.status === "refunded" ||
//                       token.status === "refund processed" ||
//                       token.status === "adjusted") && (
//                       <LeadStatusChip
//                         label={token.status}
//                         icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
//                         style={{
//                           color: "#E62E05",
//                           backgroundColor: "#FFF4ED",
//                         }}
//                       ></LeadStatusChip>
//                     )}
//                     {token.status === "expired" && (
//                       <LeadStatusChip
//                         label={token.status}
//                         icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
//                         style={{
//                           color: "#0E7090",
//                           backgroundColor: "#ECFDFF",
//                         }}
//                       ></LeadStatusChip>
//                     )}
//                     {token.status === "cancelled" && (
//                       <LeadStatusChip
//                         label={token.status}
//                         icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
//                         style={{
//                           color: "#B42318",
//                           backgroundColor: "#FEF3F2",
//                         }}
//                       ></LeadStatusChip>
//                     )}
//                     {token.status === "refund rejected" && (
//                       <LeadStatusChip
//                         style={{
//                           color: "#5925DC",
//                           backgroundColor: "#F4F3FF",
//                         }}
//                         label={token.status}
//                         icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
//                       />
//                     )}
//                     {token?.eventTokenId?.tokenId?.isPreselect &&
//                       allotment?.preselectConfirmation ===
//                         "confirmation pending" &&
//                       token.status !== "expired" &&
//                       !allotment?.status?.includes("Refund") && (
//                         <LeadStatusChip
//                           label={"Confirmation Pending"}
//                           icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
//                           style={{
//                             color: "#B54708",
//                             backgroundColor: "#FFFAEB",
//                           }}
//                         ></LeadStatusChip>
//                       )}
//                     {token.eventTokenId.tokenId.isPreselect &&
//                       !token.kycFormFilled && (
//                         <LeadStatusChip
//                           label={"Kyc Pending"}
//                           icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
//                           style={{
//                             color: "#0E7090",
//                             backgroundColor: "#ECFDFF",
//                           }}
//                         ></LeadStatusChip>
//                       )}
//                     {token.eventTokenId.tokenId.isPreselect &&
//                       token.kycFormFilled && (
//                         <LeadStatusChip
//                           label={"KYC Done"}
//                           icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
//                           style={{
//                             color: "#0E7090",
//                             backgroundColor: "#ECFDFF",
//                           }}
//                         ></LeadStatusChip>
//                       )}
//                   </div>
//                 </div>
//               </div>
//               <div className={cssClasses.tokenLastUpdate}>
//                 <ReactTimeAgo
//                   style={{ fontSize: "1.2rem" }}
//                   date={token?.last_updated_at ?? token?.created_at}
//                   locale="en-US"
//                 />
//               </div>
//             </div>
//             {/* <div className={cssClasses.tokenDataShow}>
// 							<div className={cssClasses.tokenNoData}>
// 								<span className={cssClasses.tokenNoData}>{token.eventTokenId.tokenId.name}</span>
// 							</div>
// 						</div> */}
//             <div className={cssClasses.tokenCardDetails}>
//               <div className={cssClasses.tokeDetailsHeader}>
//                 <div>
//                   <span>{token.eventId.title}</span>
//                 </div>
//                 {/* <div>
// 								{token.eventTokenId.tokenId.isPreselect && (
// 									<span>
// 										<LeadStatusChip
// 											label={"Preselect"}
// 											icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
// 											style={{
// 												color: "#5925DC",
// 												backgroundColor: "#EBE9FE",
// 											}}
// 										></LeadStatusChip>
// 									</span>
// 								)}
// 							</div> */}
//               </div>
//               <div className={cssClasses.tokenProjectData}>
//                 {token.eventTokenId.tokenId.isPreselect && (
//                   <span>{token.projectDetails}</span>
//                 )}
//               </div>
//               <div className={cssClasses.tokenBoughtSection}>
//                 <div className={cssClasses.tokenBoughtData}>
//                   <div className={cssClasses.dateText}>
//                     <img src={BoughtOnIcon} alt="bought" />
//                     <span>Bought on :</span>
//                   </div>
//                   <span>
//                     {new Date(token.created_at).toDateString()},{" "}
//                     {new Date(token.created_at).toLocaleTimeString([], {
//                       hour: "2-digit",
//                       minute: "2-digit",
//                     })}
//                   </span>
//                 </div>
//                 <div className={cssClasses.tokenBoughtData}>
//                   <div className={cssClasses.dateText}>
//                     <img src={ValidTillIcon} alt="valid" />
//                     <span>Valid Till :</span>
//                   </div>
//                   <span>{token.validity}</span>
//                 </div>
//               </div>
//               {token.paidAmount >= token.amount &&
//                 token?.TokenTransactions?.length > 0 && (
//                   <div className={cssClasses.tokenBoughtSection}>
//                     <div className={cssClasses.tokenBoughtData}>
//                       <div className={cssClasses.dateText}>
//                         <img src={ValidTillIcon} alt="token" />
//                         <span>Token Payment Complete :</span>
//                       </div>
//                       <span style={{ fontWeight: "600" }}>
//                         {tokenPaymentComplete(token.TokenTransactions)}
//                       </span>
//                     </div>
//                   </div>
//                 )}
//             </div>
//             {token.expiry && (
//               <>
//                 {token.expiry > serverTime &&
//                   token.paidAmount === 0 &&
//                   !token.eventTokenId.tokenId.isPreselect && (
//                     <div className={cssClasses.timerWrap}>
//                       Expires On :
//                       <MyTimer
//                         showIcon={false}
//                         css={{
//                           fontSize: "1.8rem",
//                           color: "#B42318",
//                         }}
//                         expiryTimestamp={token.expiry}
//                         onExpire={() => {
//                           console.log("current token", token);
//                           setOpenTokenPaymentModal(false);
//                           // ! if priority pass; delete row from EventTokenLeadRelation & revert isPrerequisiteUsed & linkedTokenId of prerequisite token
//                           // if (token.eventTokenId.tokenId.isPriorityPass && token.paidAmount === 0) {
//                           // 	console.log("calling cancel priority pass token now for ", token);
//                           // 	cancelPriorityPassToken(token);
//                           // }
//                         }}
//                       />
//                     </div>
//                   )}
//               </>
//             )}
//             {allotment.showConfirmBtn &&
//               allotment.preselectConfirmation === "confirmation pending" &&
//               token?.status !== "expired" && (
//                 <div className={cssClasses.allotmentPaymentPriceBreakDown}>
//                   {arrayContains("BSP", allotment.showPreselectPrices) && (
//                     <div className={cssClasses.allotmentPaymentPrice1}>
//                       <span className={cssClasses.allotmentPriceText}>
//                         Agreement Value:
//                       </span>
//                       <span>₹ {numberWithCommas(updatedUnitCost?.bsp)}</span>
//                     </div>
//                   )}

//                   {arrayContains("SDR", allotment.showPreselectPrices) && (
//                     <div className={cssClasses.allotmentPaymentPrice1}>
//                       <span className={cssClasses.allotmentPriceText}>
//                         SDR :
//                       </span>
//                       <span>₹ {numberWithCommas(updatedUnitCost?.sdr)}</span>
//                     </div>
//                   )}

//                   {arrayContains("GST", allotment.showPreselectPrices) && (
//                     <div className={cssClasses.allotmentPaymentPrice1}>
//                       <span className={cssClasses.allotmentPriceText}>
//                         GST :
//                       </span>
//                       <span>₹ {numberWithCommas(updatedUnitCost?.gst)}</span>
//                     </div>
//                   )}
//                 </div>
//               )}
//             {console.log("allotment===>", allotment)}
//             <div className={cssClasses.desktopDiv}>
//               {allotment?.status !== "Cancelled" &&
//                 !allotment?.status?.includes("Refund") &&
//                 allotment.showConfirmBtn &&
//                 allotment.preselectConfirmation === "confirmation pending" && (
//                   <div className={cssClasses.totalAmt}>
//                     <span className={cssClasses.amtBtnsText}>Unit Cost : </span>
//                     <span>₹ {numberWithCommas(updatedUnitCost?.total)}</span>
//                   </div>
//                 )}
//             </div>
//             <div>
//               {allotment?.eventId === "8b8850e2-a9ad-4649-aee1-9fad130bc280" &&
//                 allotment?.status !== "Cancelled" &&
//                 !allotment?.status?.includes("Refund") &&
//                 // new Date(allotment?.timer) < new Date(serverTime) &&
//                 // new Date(allotment?.closeTimer) > new Date(serverTime) &&
//                 allotment.showConfirmBtn &&
//                 allotment?.preselectConfirmation === "confirmation pending" &&
//                 token?.status !== "expired" && (
//                   <div
//                     className={cssClasses.backgroundDiv}
//                     style={{ padding: "1rem", textAlign: "left" }}
//                   >
//                     <div style={{ fontWeight: "bold" }}>SPECIAL CASHBACK !</div>
//                     <div>
//                       If you CONFIRM now, an additional Discount CashBack of
//                       Rs.1,00,000 from the Total Unit Cost mentioned here, will
//                       be applicable to you at the time of your Agreement !
//                       <span style={{ fontWeight: "bold" }}>
//                         {" "}
//                         Happy Diwali !
//                       </span>
//                     </div>
//                   </div>
//                 )}
//             </div>
//             {allotment?.eventId === "90d401ad-fe80-4295-95ab-07be3850d17b" &&
//               allotment?.launchId === "373dfbbf-3edb-45bc-8a08-c174140c2a34" &&
//               allotment?.status !== "Cancelled" &&
//               !allotment?.status?.includes("Refund") &&
//               allotment.showConfirmBtn &&
//               allotment?.preselectConfirmation === "confirmation pending" &&
//               token?.status !== "expired" && (
//                 <div className={cssClasses.imageContainer}>
//                   <img src={DiscountImg} alt="Description of the image" />
//                 </div>
//               )}
//             <div className={cssClasses.cardFooter}>
//               <div className={cssClasses.cardFooterAmount}>
//                 <div className={cssClasses.amtText}>
//                   <span>TOKEN AMOUNT </span>
//                   {token.eventTokenId.tokenId.isPriorityPass && (
//                     <span className={cssClasses.amount}>
//                       ₹{" "}
//                       {numberWithCommas(
//                         token.amount +
//                           (token.upgradedFrom ? token.upgradedFrom.amount : 0)
//                       )}
//                     </span>
//                   )}
//                   {!token.eventTokenId.tokenId.isPriorityPass && (
//                     <span className={cssClasses.amount}>
//                       ₹ {numberWithCommas(token.amount)}
//                     </span>
//                   )}
//                 </div>
//                 {((token.paidAmount > 0 &&
//                   !token.eventTokenId.tokenId.isPriorityPass) ||
//                   token.eventTokenId.tokenId.isPriorityPass) && (
//                   <>
//                     <Divider orientation="vertical" flexItem />
//                     <div className={cssClasses.amtText}>
//                       <>
//                         <span>PAID AMOUNT </span>
//                         {token.eventTokenId.tokenId.isPriorityPass && (
//                           <span className={cssClasses.amount}>
//                             ₹{" "}
//                             {numberWithCommas(
//                               token.paidAmount +
//                                 (token.upgradedFrom
//                                   ? token.upgradedFrom.paidAmount
//                                   : 0)
//                             )}
//                           </span>
//                         )}
//                         {!token.eventTokenId.tokenId.isPriorityPass && (
//                           <span className={cssClasses.amount}>
//                             ₹ {numberWithCommas(token.paidAmount)}
//                           </span>
//                         )}
//                       </>
//                     </div>
//                   </>
//                 )}
//               </div>
//               {console.log(token)}
//               <div
//                 className={cssClasses.tokenButtonContent}
//                 style={{ justifyContent: isWrap ? "flex-end" : "" }}
//               >
//                 <div className={cssClasses.tokenConfirmBtnWrap}>
//                   {/* If token is active then add book now button for dashboard */}

//                   {token.status === "active" &&   isBookingAvailable &&
//                     // token?.eventTokenId?.eventTokenId ===
//                     //   "ea5ac42b-cffa-4a38-814e-637d82d381af" && (
//                       <div
//                         className={cssClasses.tokenButtonContent}
//                         style={{ justifyContent: "flex-end" }}
//                       >
//                         <div>
//                           {timeRemaining === null ? null : !isTimerFinished? (
//                             <div
//                               style={{
//                                 color: "#fff",
//                                 backgroundColor: "#1570EF",
//                                 fontSize: "1.4rem",
//                                 lineHeight: "2rem",
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 padding: "5px",
//                                 borderRadius: "5px",
//                               }}
//                             >
//                               <div>Booking Starts In</div>
//                               <div>{timeRemaining}</div>
//                             </div>
//                           ) : (
//                             <Button
//                             btnName={
//     <div
//       style={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         minWidth: "120px", // ensures consistent width
//       }}
//     >
//       {loading ? (
//         <CircularProgress size={22} sx={{ color: "white" }} />
//       ) : (
//         "BOOK NOW"
//       )}
//     </div>
//   }
//         clicked={handleBooking}
//         disabled={loading}
//                               style={{
//                                 color: "#fff",
//                                 backgroundColor: "#1570EF",
//                                 fontSize: "1.4rem",
//                                 lineHeight: "2rem",
//                                 fontFamily: "Inter-Medium !important",
//                                 minWidth: "120px",
//                               }}
//                             />
//                           )}
//                         </div>
//                       </div>
//                     }
//                   {(token.status === "alloted" ||
//                     token.status === "refund rejected") &&
//                     token.eventTokenId.tokenId.isPreselect &&
//                     !token.kycFormFilled && (
//                       <div style={{ display: "flex" }}>
//                         <Button
//                           btnName={"Fill KYC"}
//                           clicked={() => {
//                             setCurrentAllotmentPayment(
//                               token.allotmentPaymentId
//                             );
//                             setOpenBookingFormModal(true);
//                           }}
//                           style={{
//                             width: "12rem",
//                             color: "#fff",
//                             backgroundColor: "rgb(21, 112, 239)",
//                             fontSize: "1.4rem",
//                             lineHeight: "2rem",
//                             fontFamily: "Inter-Medium !important",
//                           }}
//                         ></Button>
//                       </div>
//                     )}
//                   {token.expiry && (
//                     <>
//                       {/* {!token.eventTokenId.tokenId.isPreselect && !token.eventTokenId.tokenId.isPriorityPass && ( */}
//                       {!token.eventTokenId.tokenId.isPreselect && (
//                         <>
//                           {/* {token.expiry > Date.now() && token.paidAmount < token.amount && ( */}
//                           {((token.paidAmount === 0 &&
//                             token.expiry > serverTime) ||
//                             (token.paidAmount > 0 &&
//                               token.paidAmount < token.amount)) &&
//                             !token.status.includes("refund") && (
//                               <>
//                                 <Button
//                                   btnName={"Pay Now"}
//                                   clicked={() => {
//                                     if (
//                                       token.eventTokenId.tokenId.isPriorityPass
//                                     ) {
//                                       // ! limit is checked based on this token's eventTokenId
//                                       setSelectedTokenPaymentData(
//                                         token.eventTokenId
//                                       );
//                                     } else {
//                                       setSelectedTokenPaymentData(null);
//                                     }
//                                     setTokenObj(token);
//                                     // if (token.eventTokenId.tokenId.isPreselect) {

//                                     setSelectedToken(token);
//                                     setOpenTokenPaymentModal(true);
//                                     // } else {
//                                     //     openTokenPayment(token);
//                                     // }
//                                   }}
//                                   style={{
//                                     width:
//                                       window.innerWidth > 1366
//                                         ? "100%"
//                                         : "auto",
//                                     color: "#fff",
//                                     backgroundColor: "rgb(21, 112, 239)",
//                                     fontSize: "1.4rem",
//                                     lineHeight: "2rem",
//                                     fontFamily: "Inter-Medium !important",
//                                     whiteSpace: "nowrap !important",
//                                   }}
//                                 ></Button>
//                               </>
//                             )}
//                         </>
//                       )}
//                     </>
//                   )}
//                   {token.eventTokenId.tokenId.isPreselect &&
//                     !token.eventTokenId.tokenId.isPriorityPass &&
//                     !token.allotmentPaymentId?.status
//                       .toLowerCase()
//                       .includes("cancel") && (
//                       <>
//                         {(token.paidAmount === 0 ||
//                           (token.paidAmount > 0 &&
//                             token.paidAmount < token.amount)) && (
//                           <>
//                             <Button
//                               btnName={"Pay Now"}
//                               clicked={() => {
//                                 setTokenObj(token);
//                                 // if (token.eventTokenId.tokenId.isPreselect) {
//                                 setSelectedToken(token);
//                                 setOpenTokenPaymentModal(true);
//                                 // } else {
//                                 //     openTokenPayment(token);
//                                 // }
//                               }}
//                               style={{
//                                 width:
//                                   window.innerWidth > 1366 ? "100%" : "auto",
//                                 color: "#fff",
//                                 backgroundColor: "rgb(21, 112, 239)",
//                                 fontSize: "1.4rem",
//                                 lineHeight: "2rem",
//                                 fontFamily: "Inter-Medium !important",
//                               }}
//                             ></Button>
//                           </>
//                         )}
//                       </>
//                     )}
//                 </div>
//                 {token.upgradedFrom && (
//                   <div className={cssClasses.tokentokenViewBtnWrap}>
//                     {token.upgradedFrom && (
//                       <div className={cssClasses.confirmBtnWrap}>
//                         <Button
//                           btnName={"View Linked Token"}
//                           clicked={() => {
//                             setTokenObj(token);
//                             setOpenLinkedTokenModal(true);
//                             // if (token.eventTokenId.tokenId.isPreselect) {
//                             // } else {
//                             //     openTokenPayment(token);
//                             // }
//                           }}
//                           style={{
//                             width: window.innerWidth > 1366 ? "100%" : "100%",
//                             color: "#344054",
//                             backgroundColor: "#fff",
//                             fontSize: "1.4rem",
//                             lineHeight: "2rem",
//                             fontFamily: "Inter-Medium !important",
//                             borderRadius: "8px",
//                             border: "1px solid #D0D5DD",
//                             boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
//                             fontWeight: "500",
//                           }}
//                         ></Button>
//                       </div>
//                     )}
//                   </div>
//                 )}
//                 {!isMobileView &&
//                   allotment?.status !== "Cancelled" &&
//                   !allotment?.status?.includes("Refund") &&
//                   // new Date(allotment?.timer) < new Date(serverTime) &&
//                   // new Date(allotment?.closeTimer) > new Date(serverTime) &&
//                   allotment.showConfirmBtn &&
//                   allotment?.preselectConfirmation === "confirmation pending" &&
//                   token?.status !== "expired" && (
//                     <div className={cssClasses.confirmBtnWrap}>
//                       <Button
//                         btnName={"Confirm"}
//                         clicked={() => {
//                           setOpenConfirmationModal(true);
//                         }}
//                         style={{
//                           width: window.innerWidth > 1366 ? "100%" : "auto",
//                           color: "#fff",
//                           backgroundColor: "rgb(21, 112, 239)",
//                           fontSize: "1.4rem",
//                           lineHeight: "2rem",
//                           fontFamily: "Inter-Medium !important",
//                           alignSelf: "flex-end",
//                         }}
//                       ></Button>
//                     </div>
//                   )}
//               </div>
//               {/* {!isMobileView &&
//                 allotment?.status !== "Cancelled" &&
//                 new Date(allotment?.timer) < new Date(serverTime) &&
//                 new Date(allotment?.closeTimer) > new Date(serverTime) &&
//                 allotment?.preselectConfirmation === "confirmation pending" && (
//                   <div className={cssClasses.confirmBtnWrap}>
//                     <Button
//                       btnName={"Confirm"}
//                       clicked={() => {
//                         setOpenConfirmationModal(true);
//                       }}
//                       style={{
//                         width: window.innerWidth > 1366 ? "100%" : "auto",
//                         color: "#fff",
//                         backgroundColor: "rgb(21, 112, 239)",
//                         fontSize: "1.4rem",
//                         lineHeight: "2rem",
//                         fontFamily: "Inter-Medium !important",
//                         alignSelf: "flex-end",
//                       }}
//                     ></Button>
//                   </div>
//                 )} */}
//             </div>

//             {token.isPrerequisiteAvailable && token.status === "active" && (
//               <div className={cssClasses.tokenConfirmBtnWrapPriority}>
//                 {token.timer && !token.isPrerequisiteUsed && (
//                   // <p style={{ fontSize: "1.4rem", fontStyle: "italic" }}>{token.prerequisiteMsg}</p>
//                   <div className={cssClasses.timerWrap}>
//                     Priority Pass starts at{" "}
//                     <MyTimer
//                       css={{ fontSize: "1.8rem", color: "#B42318" }}
//                       expiryTimestamp={token.timer}
//                       onExpire={() => {
//                         token.showPPBtn = true;
//                         token.timer = null;
//                       }}
//                     />
//                   </div>
//                 )}
//                 {!token.isPrerequisiteUsed &&
//                   token.timer <= serverTime &&
//                   serverTime < token.closeTimer && (
//                     // <p style={{ fontSize: "1.4rem", fontStyle: "italic" }}>{token.prerequisiteMsg}</p>
//                     <div className={cssClasses.timerWrap}>
//                       Expires in{" "}
//                       <MyTimer
//                         css={{ fontSize: "1.8rem", color: "#B42318" }}
//                         expiryTimestamp={token.closeTimer}
//                         onExpire={() => {
//                           token.showPPBtn = false;
//                           token.closeTimer = null;
//                           setOpenBuyTokenModal(false);
//                         }}
//                       />
//                     </div>
//                   )}
//                 {/* {token.timer <= new Date().getTime() && !token.isPrerequisiteUsed && */}
//                 {token.showPPBtn && (
//                   <Button
//                     btnName={"Buy Priority Pass Now"}
//                     clicked={() => {
//                       setTokenObj(token);
//                       // if (token.eventTokenId.tokenId.isPreselect) {
//                       // setSelectedToken(token)
//                       setUpgradableTokens(token.upgradableTokens);
//                       setPrereqToken(token);
//                       setOpenBuyTokenModal(true);
//                       setSelectedData(token);
//                       // } else {
//                       //     openTokenPayment(token);
//                       // }
//                     }}
//                     style={{
//                       width: "auto",
//                       color: "#fff",
//                       backgroundColor: "rgb(21, 112, 239)",
//                       fontSize: "1.4rem",
//                       lineHeight: "2rem",
//                       fontFamily: "Inter-Medium !important",
//                     }}
//                   ></Button>
//                 )}
//               </div>
//             )}
//             <div
//               style={{
//                 width: "100%",
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 gap: "0.8rem",
//               }}
//             >
//               {allotment?.status !== "Cancelled" &&
//                 !allotment?.status?.includes("Refund") &&
//                 // new Date(allotment?.timer) < new Date(serverTime) &&
//                 // new Date(allotment.closeTimer) > new Date(serverTime) &&
//                 allotment.showConfirmBtn &&
//                 allotment?.preselectConfirmation === "confirmation pending" && (
//                   <div className={cssClasses.timerWrap}>
//                     {/* Expires in <MyTimer css={{ fontSize: "1.8rem", color: "#98A2B3" }} expiryTimestamp={allotment.closeTimer} */}
//                     Expires in{" "}
//                     <MyTimer
//                       css={{ fontSize: "1.6rem", color: "#E17A00" }}
//                       preselectConfirm={true}
//                       expiryTimestamp={allotment.closeTimer}
//                       svgStyle={{
//                         transform: "scale(1.5)",
//                       }}
//                       onExpire={() => {
//                         setOpenConfirmationModal(false);
//                       }}
//                     />
//                   </div>
//                 )}
//               {isMobileView &&
//                 allotment?.status !== "Cancelled" &&
//                 // new Date(allotment?.timer) < new Date(serverTime) &&
//                 // new Date(allotment?.closeTimer) > new Date(serverTime) &&
//                 allotment.showConfirmBtn &&
//                 allotment?.preselectConfirmation === "confirmation pending" && (
//                   <div className={cssClasses.confirmBtnWrap}>
//                     <Button
//                       btnName={"Confirm"}
//                       clicked={() => {
//                         setOpenConfirmationModal(true);
//                       }}
//                       style={{
//                         width: window.innerWidth > 1366 ? "100%" : "auto",
//                         color: "#fff",
//                         backgroundColor: "rgb(21, 112, 239)",
//                         fontSize: "1.4rem",
//                         lineHeight: "2rem",
//                         fontFamily: "Inter-Medium !important",
//                         alignSelf: "flex-end",
//                       }}
//                     ></Button>
//                   </div>
//                 )}
//             </div>

//             {allotment.status !== "Cancelled" &&
//               allotment.status !== "Refund Processed" &&
//               allotment.status !== "Released" &&
//               allotment.status !== "Refund Initiated" && (
//                 <div className={cssClasses.paymentText}>
//                   {allotment?.paidAmount < allotment?.paymentId?.amount ? (
//                     <>
//                       <p
//                         style={{
//                           fontSize: "1.4rem",
//                           fontStyle: "italic",
//                           color: "red",
//                         }}
//                       >
//                         Please complete payment!
//                       </p>
//                     </>
//                   ) : (
//                     <>
//                       {allotment.showMsg &&
//                       !allotment.showConfirmBtn &&
//                       allotment.preselectConfirmation ===
//                         "confirmation pending" &&
//                       !allotment.isExpired ? (
//                         <>
//                           <p
//                             style={{ fontSize: "1.4rem", fontStyle: "italic" }}
//                           >
//                             Preselect Confirmations will start from{" "}
//                             <b>
//                               {new Date(
//                                 allotment?.paymentId?.eventTokenId.eventId.preselectConfirmationConfig.startDateTime
//                               ).toDateString()}{" "}
//                               {new Date(
//                                 allotment?.paymentId?.eventTokenId.eventId.preselectConfirmationConfig.startDateTime
//                               ).toLocaleTimeString()}
//                             </b>
//                           </p>
//                         </>
//                       ) : !allotment.showConfirmBtn &&
//                         !allotment.showMsg &&
//                         allotment?.preselectConfirmation ===
//                           "confirmation pending" &&
//                         !allotment.isExpired ? (
//                         <>
//                           <p
//                             style={{ fontSize: "1.4rem", fontStyle: "italic" }}
//                           >
//                             Preselect Confirmations will start soon!
//                           </p>
//                         </>
//                       ) : (
//                         ""
//                       )}
//                     </>
//                   )}
//                 </div>
//               )}
//           </Card>
//         )}
//         {openTokenPaymentModal && (
//           <TokenPayment
//             payableTokenData={selectedTokenPaymentData}
//             open={openTokenPaymentModal}
//             tokenPaymentResponse={updateTokenTables}
//             tokenDetails={selectedToken}
//             handleClose={() => {
//               setOpenTokenPaymentModal(false);
//               setSelectedToken(null);
//             }}
//           />
//         )}
//         {openBuyTokenModal && (
//           <BuyToken
//             open={openBuyTokenModal}
//             handleClose={() => {
//               setOpenBuyTokenModal(false);
//             }}
//             availableTokens={upgradableTokens}
//             tokenSelectionResponse={(token) => {
//               setSelectedTokenPaymentData(token);
//               // addTokenPayment(token);
//               // !vedashree changes
//               addPriorityPasstoken(token);
//               // ! gaurav changes
//               // presentLoader();
//               // let obj = {
//               //   token: token,
//               //   leadId: selectedLead.leadId,
//               //   paymentId: prereqToken.paymentId
//               // }
//               // setTokenObj(selectedData);
//               // setSelectedToken(selectedData);

//               // dismissLoader()
//               // ! sarita changes
//               // ${process.env.REACT_APP_PAYMENT_LINK_URL}
//               // axios.post(` ${process.env.REACT_APP_PAYMENT_LINK_URL}priorityPass/enqueue`, obj).then((resp) => {
//               //
//               //   //  let abc = setInterval(async () => {
//               //   //   await getQueueStatus(resp).then((response)=>{
//               //   //
//               //   //   if (response.data.status === 'complete'){
//               //   //     dismissLoader();
//               //   //     clearInterval(abc);
//               //   //     if(!response.data.success){
//               //   //
//               //   //       errorTost(`You cannot buy ${token?.tokenId?.name} now as the limit has exceeded!`);
//               //   //     }
//               //   //   }
//               //   //   }).catch((err)=>{
//               //   //
//               //   //   });
//               //   //  }, 1000);
//               //   // ??Recursive calls until we get response as res.data.status === 'complete'
//               //   // getQueueStatusRecursive(resp, token?.tokenId?.name);
//               //   dismissLoader()
//               // }).catch((err) => {
//               //   dismissLoader();
//               //
//               // });
//             }}
//           />
//         )}
//         {openLinkedTokenModal && (
//           <LinkedToken
//             open={openLinkedTokenModal}
//             handleClose={() => {
//               setOpenLinkedTokenModal(false);
//             }}
//             selectedToken={tokenObj}
//           />
//         )}
//         {openConfirmationModal && (
//           <PreselectConfirmation
//             allotmentDetails={allotment}
//             open={openConfirmationModal}
//             handleClose={() => setOpenConfirmationModal(false)}
//             returnResp={UpdatePreselectUpdate}
//           />
//         )}
//         {openCong && (
//           <Congratulation
//             open={openCong}
//             handleClose={() => setOpenCong(false)}
//             time={8000}
//           />
//         )}
//         {openBookingFormModal && (
//           <BookingForm
//             allotment={currentAllotmentPayment}
//             open={openBookingFormModal}
//             handleClose={() => {
//               setOpenBookingFormModal(false);
//             }}
//           />
//         )}
//       </div>
//     </>
//   );
// };

// export default Token;
